export default [
    { "Country": "AX", "City": "Mariehamn" },
    { "Country": "CW", "City": "Willemstad" },
    { "Country": "AS", "City": "Pago-Pago" }, 
    { "Country": "AD", "City": "Andorra-la-Vella" }, 
    { "Country": "AF", "City": "Charikar" }, 
    { "Country": "AF", "City": "Kabul" }, 
    { "Country": "AL", "City": "Berat" }, 
    { "Country": "AL", "City": "Burrel" }, 
    { "Country": "AL", "City": "Elbasan" }, 
    { "Country": "AL", "City": "Fier" }, 
    { "Country": "AL", "City": "Lushnje" }, 
    { "Country": "AL", "City": "Pogradec" }, 
    { "Country": "AL", "City": "Shkoder" }, 
    { "Country": "AL", "City": "Tirana" }, 
    { "Country": "BM", "City": "Hamilton" }, 
    { "Country": "BT", "City": "Thimphu" }, 
    { "Country": "BV", "City": "Bouvet-Island" }, 
    { "Country": "BN", "City": "Bandar-Seri-Begawan" }, 
    { "Country": "CV", "City": "Praia" }, 
    { "Country": "KY", "City": "George-Town" }, 
    { "Country": "IO", "City": "British-Indian-Ocean-Territory" }, 
    { "Country": "DZ", "City": "Adrar" }, 
    { "Country": "DZ", "City": "Algiers" }, 
    { "Country": "DZ", "City": "Annaba" }, 
    { "Country": "DZ", "City": "Biskra" }, 
    { "Country": "DZ", "City": "Blida" }, 
    { "Country": "DZ", "City": "Bouira" }, 
    { "Country": "DZ", "City": "Constantine" }, 
    { "Country": "DZ", "City": "Djelfa" }, 
    { "Country": "DZ", "City": "Guelma" }, 
    { "Country": "DZ", "City": "Illizi" }, 
    { "Country": "DZ", "City": "Jijel" }, 
    { "Country": "DZ", "City": "Khenchela" }, 
    { "Country": "DZ", "City": "Laghouat" }, 
    { "Country": "DZ", "City": "Mascara" }, 
    { "Country": "DZ", "City": "Medea" }, 
    { "Country": "DZ", "City": "Mila" }, 
    { "Country": "DZ", "City": "Mostaganem" }, 
    { "Country": "DZ", "City": "M'sila" }, 
    { "Country": "DZ", "City": "Oran" }, 
    { "Country": "DZ", "City": "Ouargla" }, 
    { "Country": "DZ", "City": "Relizane" }, 
    { "Country": "DZ", "City": "Saida" }, 
    { "Country": "DZ", "City": "Skikda" }, 
    { "Country": "DZ", "City": "Tindouf" }, 
    { "Country": "DZ", "City": "Tipasa" }, 
    { "Country": "DZ", "City": "Tissemsilt" }, 
    { "Country": "DZ", "City": "The-Valley" }, 
    { "Country": "AI", "City": "Touggourt" }, 
    { "Country": "AQ", "City": "Antarctica" }, 
    { "Country": "AG", "City": "Saint-John's" }, 
    { "Country": "AW", "City": "Oranjestad" }, 
    { "Country": "AO", "City": "Benguela" }, 
    { "Country": "AO", "City": "Huambo" }, 
    { "Country": "AO", "City": "Lobito" }, 
    { "Country": "AO", "City": "Luanda" }, 
    { "Country": "AO", "City": "Lubango" }, 
    { "Country": "AR", "City": "Balcarce" }, 
    { "Country": "AR", "City": "Campana" }, 
    { "Country": "AR", "City": "Chamical" }, 
    { "Country": "AR", "City": "Chascomus" }, 
    { "Country": "AR", "City": "Chilecito" }, 
    { "Country": "AR", "City": "Chivilcoy" }, 
    { "Country": "AR", "City": "Corrientes" }, 
    { "Country": "AR", "City": "Formosa" }, 
    { "Country": "AR", "City": "Goya" }, 
    { "Country": "AR", "City": "Gualeguay" }, 
    { "Country": "AR", "City": "Junin" }, 
    { "Country": "AR", "City": "Lobos" }, 
    { "Country": "AR", "City": "Mendoza" }, 
    { "Country": "AR", "City": "Mercedes" }, 
    { "Country": "AR", "City": "Pergamino" }, 
    { "Country": "AR", "City": "Posadas" }, 
    { "Country": "AR", "City": "Rawson" }, 
    { "Country": "AR", "City": "Reconquista" }, 
    { "Country": "AR", "City": "Resistencia" }, 
    { "Country": "AR", "City": "Rosario" }, 
    { "Country": "AR", "City": "Salta" }, 
    { "Country": "AR", "City": "Ushuaia" }, 
    { "Country": "AM", "City": "Armavir" }, 
    { "Country": "AM", "City": "Ashtarak" }, 
    { "Country": "AM", "City": "Gyumri" }, 
    { "Country": "AM", "City": "Hrazdan" }, 
    { "Country": "AM", "City": "Vanadzor" }, 
    { "Country": "AM", "City": "Yerevan" }, 
    { "Country": "AU", "City": "Adelaide" }, 
    { "Country": "AU", "City": "Brisbane" }, 
    { "Country": "AU", "City": "Caboolture" }, 
    { "Country": "AU", "City": "Canberra" }, 
    { "Country": "AU", "City": "Melbourne" }, 
    { "Country": "AU", "City": "Perth" }, 
    { "Country": "AU", "City": "Sydney" }, 
    { "Country": "AU", "City": "Townsville" }, 
    { "Country": "AT", "City": "Innsbruck" }, 
    { "Country": "AT", "City": "Linz" }, 
    { "Country": "AT", "City": "Vienna" }, 
    { "Country": "AZ", "City": "Baku" }, 
    { "Country": "AZ", "City": "Lankaran" }, 
    { "Country": "AZ", "City": "Sabirabad" }, 
    { "Country": "AZ", "City": "Xirdalan" }, 
    { "Country": "BS", "City": "Freeport" }, 
    { "Country": "BS", "City": "Nassau" }, 
    { "Country": "BH", "City": "Manama" }, 
    { "Country": "BD", "City": "Chittagong" }, 
    { "Country": "BD", "City": "Comilla" }, 
    { "Country": "BD", "City": "Dhaka" }, 
    { "Country": "BD", "City": "Jessore" }, 
    { "Country": "BD", "City": "Khulna" }, 
    { "Country": "BD", "City": "Mymensingh" }, 
    { "Country": "BD", "City": "Narayanganj" }, 
    { "Country": "BD", "City": "Sylhet" }, 
    { "Country": "BB", "City": "Bridgetown" }, 
    { "Country": "BY", "City": "Babruysk" }, 
    { "Country": "BY", "City": "Hrodna" }, 
    { "Country": "BY", "City": "Maladzyechna" }, 
    { "Country": "BY", "City": "Mazyr" }, 
    { "Country": "BY", "City": "Minsk" }, 
    { "Country": "BE", "City": "Brussels" }, 
    { "Country": "BE", "City": "Charleroi" }, 
    { "Country": "BE", "City": "Namur" }, 
    { "Country": "BZ", "City": "Belmopan" }, 
    { "Country": "BZ", "City": "Corozal" }, 
    { "Country": "BJ", "City": "Cotonou" }, 
    { "Country": "BJ", "City": "Lokossa" }, 
    { "Country": "BJ", "City": "Natitingou" }, 
    { "Country": "BJ", "City": "Porto-Novo" }, 
    { "Country": "BO", "City": "Cochabamba" }, 
    { "Country": "BO", "City": "Sucre" }, 
    { "Country": "BO", "City": "Tarija" }, 
    { "Country": "BO", "City": "Trinidad" }, 
    { "Country": "BA", "City": "Brcko" }, 
    { "Country": "BA", "City": "Mostar" }, 
    { "Country": "BA", "City": "Prijedor" }, 
    { "Country": "BA", "City": "Sarajevo" }, 
    { "Country": "BA", "City": "Tuzla" }, 
    { "Country": "BA", "City": "Zenica" }, 
    { "Country": "BW", "City": "Francistown" }, 
    { "Country": "BW", "City": "Gaborone" }, 
    { "Country": "BR", "City": "Abaetetuba" }, 
    { "Country": "BR", "City": "Acu" }, 
    { "Country": "BR", "City": "Altamira" }, 
    { "Country": "BR", "City": "Alvorada" }, 
    { "Country": "BR", "City": "Americana" }, 
    { "Country": "BR", "City": "Aracaju" }, 
    { "Country": "BR", "City": "Aracuai" }, 
    { "Country": "BR", "City": "Arapiraca" }, 
    { "Country": "BR", "City": "Arcoverde" }, 
    { "Country": "BR", "City": "Barbacena" }, 
    { "Country": "BR", "City": "Barreiras" }, 
    { "Country": "BR", "City": "Barreiros" }, 
    { "Country": "BR", "City": "Barretos" }, 
    { "Country": "BR", "City": "Bauru" }, 
    { "Country": "BR", "City": "Blumenau" }, 
    { "Country": "BR", "City": "Brumado" }, 
    { "Country": "BR", "City": "Caico" }, 
    { "Country": "BR", "City": "Cameta" }, 
    { "Country": "BR", "City": "Camocim" }, 
    { "Country": "BR", "City": "Campinas" }, 
    { "Country": "BR", "City": "Canoas" }, 
    { "Country": "BR", "City": "Canoinhas" }, 
    { "Country": "BR", "City": "Carpina" }, 
    { "Country": "BR", "City": "Caruaru" }, 
    { "Country": "BR", "City": "Cascavel" }, 
    { "Country": "BR", "City": "Castro" }, 
    { "Country": "BR", "City": "Catanduva" }, 
    { "Country": "BR", "City": "Chapadinha" }, 
    { "Country": "BR", "City": "Curitiba" }, 
    { "Country": "BR", "City": "Curvelo" }, 
    { "Country": "BR", "City": "Dourados" }, 
    { "Country": "BR", "City": "Fortaleza" }, 
    { "Country": "BR", "City": "Franca" }, 
    { "Country": "BR", "City": "Garanhuns" }, 
    { "Country": "BR", "City": "Goianesia" }, 
    { "Country": "BR", "City": "Guaira" }, 
    { "Country": "BR", "City": "Guanambi" }, 
    { "Country": "BR", "City": "Guarapuava" }, 
    { "Country": "BR", "City": "Guaratingueta" }, 
    { "Country": "BR", "City": "Imperatriz" }, 
    { "Country": "BR", "City": "Inhumas" }, 
    { "Country": "BR", "City": "Ipatinga" }, 
    { "Country": "BR", "City": "Ipora" }, 
    { "Country": "BR", "City": "Irece" }, 
    { "Country": "BR", "City": "Itabuna" }, 
    { "Country": "BR", "City": "Itapetinga" }, 
    { "Country": "BR", "City": "Jaguaquara" }, 
    { "Country": "BR", "City": "Jaguarao" }, 
    { "Country": "BR", "City": "Janauba" }, 
    { "Country": "BR", "City": "Joinville" }, 
    { "Country": "BR", "City": "Juazeiro" }, 
    { "Country": "BR", "City": "Leopoldina" }, 
    { "Country": "BR", "City": "Limeira" }, 
    { "Country": "BR", "City": "Linhares" }, 
    { "Country": "BR", "City": "Londrina" }, 
    { "Country": "BR", "City": "Manaus" }, 
    { "Country": "BR", "City": "Maracaju" }, 
    { "Country": "BR", "City": "Mineiros" }, 
    { "Country": "BR", "City": "Mossoro" }, 
    { "Country": "BR", "City": "Natal" }, 
    { "Country": "BR", "City": "Niquelandia" }, 
    { "Country": "BR", "City": "Olinda" }, 
    { "Country": "BR", "City": "Osorio" }, 
    { "Country": "BR", "City": "Palmas" }, 
    { "Country": "BR", "City": "Paracatu" }, 
    { "Country": "BR", "City": "Paracuru" }, 
    { "Country": "BR", "City": "Paragominas" }, 
    { "Country": "BR", "City": "Passos" }, 
    { "Country": "BR", "City": "Pelotas" }, 
    { "Country": "BR", "City": "Petrolina" }, 
    { "Country": "BR", "City": "Pindamonhangaba" }, 
    { "Country": "BR", "City": "Piracicaba" }, 
    { "Country": "BR", "City": "Quarai" }, 
    { "Country": "BR", "City": "Recife" }, 
    { "Country": "BR", "City": "Salvador" }, 
    { "Country": "BR", "City": "Santos" }, 
    { "Country": "BR", "City": "Sinop" }, 
    { "Country": "BR", "City": "Sobral" }, 
    { "Country": "BR", "City": "Sorocaba" }, 
    { "Country": "BR", "City": "Taua" }, 
    { "Country": "BR", "City": "Teresina" }, 
    { "Country": "BR", "City": "Tubarao" }, 
    { "Country": "BR", "City": "Uba" }, 
    { "Country": "BR", "City": "Uberaba" }, 
    { "Country": "BR", "City": "Uruguaiana" }, 
    { "Country": "BR", "City": "Vilhena" }, 
    { "Country": "BG", "City": "Blagoevgrad" }, 
    { "Country": "BG", "City": "Burgas" }, 
    { "Country": "BG", "City": "Kardzhali" }, 
    { "Country": "BG", "City": "Pazardzhik" }, 
    { "Country": "BG", "City": "Pernik" }, 
    { "Country": "BG", "City": "Pleven" }, 
    { "Country": "BG", "City": "Plovdiv" }, 
    { "Country": "BG", "City": "Shumen" }, 
    { "Country": "BG", "City": "Silistra" }, 
    { "Country": "BG", "City": "Sliven" }, 
    { "Country": "BG", "City": "Sofia" }, 
    { "Country": "BG", "City": "Varna" }, 
    { "Country": "BG", "City": "Vidin" }, 
    { "Country": "BG", "City": "Vratsa" }, 
    { "Country": "BG", "City": "Yambol" }, 
    { "Country": "BF", "City": "Ouagadougou" }, 
    { "Country": "BI", "City": "Bubanza" }, 
    { "Country": "BI", "City": "Bujumbura" }, 
    { "Country": "BI", "City": "Kayanza" }, 
    { "Country": "BI", "City": "Mwaro" }, 
    { "Country": "BI", "City": "Rutana" }, 
    { "Country": "KH", "City": "Battambang" }, 
    { "Country": "KH", "City": "Kampot" }, 
    { "Country": "CM", "City": "Bamenda" }, 
    { "Country": "CM", "City": "Buea" }, 
    { "Country": "CM", "City": "Douala" }, 
    { "Country": "CA", "City": "Abbotsford" }, 
    { "Country": "CA", "City": "Baie-Comeau" }, 
    { "Country": "CA", "City": "Calgary" }, 
    { "Country": "CA", "City": "Cornwall" }, 
    { "Country": "CA", "City": "Courtenay" }, 
    { "Country": "CA", "City": "Edmonton" }, 
    { "Country": "CA", "City": "Edmundston" }, 
    { "Country": "CA", "City": "Hamilton" }, 
    { "Country": "CA", "City": "Kitchener" }, 
    { "Country": "CA", "City": "Moncton" }, 
    { "Country": "CA", "City": "Montreal" }, 
    { "Country": "CA", "City": "Nanaimo" }, 
    { "Country": "CA", "City": "Oshawa" }, 
    { "Country": "CA", "City": "Ottawa" }, 
    { "Country": "CA", "City": "Penticton" }, 
    { "Country": "CA", "City": "Saskatoon" }, 
    { "Country": "CA", "City": "Sherbrooke" }, 
    { "Country": "CA", "City": "Toronto" }, 
    { "Country": "CA", "City": "Vancouver" }, 
    { "Country": "CA", "City": "Victoria" }, 
    { "Country": "CA", "City": "Winnipeg" }, 
    { "Country": "CF", "City": "Obo" }, 
    { "Country": "CL", "City": "Angol" }, 
    { "Country": "CL", "City": "Antofagasta" }, 
    { "Country": "CL", "City": "Arica" }, 
    { "Country": "CL", "City": "Calama" }, 
    { "Country": "CL", "City": "Chillan" }, 
    { "Country": "CL", "City": "Coquimbo" }, 
    { "Country": "CL", "City": "Coronel" }, 
    { "Country": "CL", "City": "Iquique" }, 
    { "Country": "CL", "City": "Osorno" }, 
    { "Country": "CL", "City": "Ovalle" }, 
    { "Country": "CL", "City": "Rancagua" }, 
    { "Country": "CL", "City": "Santiago" }, 
    { "Country": "CL", "City": "Talca" }, 
    { "Country": "CL", "City": "Talcahuano" }, 
    { "Country": "CL", "City": "Temuco" }, 
    { "Country": "CL", "City": "Valdivia" }, 
    { "Country": "CL", "City": "Vallenar" }, 
    { "Country": "CL", "City": "Vicuna" }, 
    { "Country": "CN", "City": "Ankang" }, 
    { "Country": "CN", "City": "Anqing" }, 
    { "Country": "CN", "City": "Anshan" }, 
    { "Country": "CN", "City": "Anyang" }, 
    { "Country": "CN", "City": "Baishan" }, 
    { "Country": "CN", "City": "Baoding" }, 
    { "Country": "CN", "City": "Baotou" }, 
    { "Country": "CN", "City": "Beihai" }, 
    { "Country": "CN", "City": "Beijing" }, 
    { "Country": "CN", "City": "Beipiao" }, 
    { "Country": "CN", "City": "Bengbu" }, 
    { "Country": "CN", "City": "Cangzhou" }, 
    { "Country": "CN", "City": "Changchun" }, 
    { "Country": "CN", "City": "Changde" }, 
    { "Country": "CN", "City": "Changsha" }, 
    { "Country": "CN", "City": "Changzhi" }, 
    { "Country": "CN", "City": "Changzhou" }, 
    { "Country": "CN", "City": "Chaoyang" }, 
    { "Country": "CN", "City": "Chaozhou" }, 
    { "Country": "CN", "City": "Chengdu" }, 
    { "Country": "CN", "City": "Chenzhou" }, 
    { "Country": "CN", "City": "Chifeng" }, 
    { "Country": "CN", "City": "Chongqing" }, 
    { "Country": "CN", "City": "Dali" }, 
    { "Country": "CN", "City": "Dalian" }, 
    { "Country": "CN", "City": "Dandong" }, 
    { "Country": "CN", "City": "Daqing" }, 
    { "Country": "CN", "City": "Datong" }, 
    { "Country": "CN", "City": "Deyang" }, 
    { "Country": "CN", "City": "Dezhou" }, 
    { "Country": "CN", "City": "Dongguan" }, 
    { "Country": "CN", "City": "Foshan" }, 
    { "Country": "CN", "City": "Fushun" }, 
    { "Country": "CN", "City": "Fuxin" }, 
    { "Country": "CN", "City": "Fuyang" }, 
    { "Country": "CN", "City": "Fuyu" }, 
    { "Country": "CN", "City": "Fuzhou" }, 
    { "Country": "CN", "City": "Ganzhou" }, 
    { "Country": "CN", "City": "Guangyuan" }, 
    { "Country": "CN", "City": "Guangzhou" }, 
    { "Country": "CN", "City": "Guilin" }, 
    { "Country": "CN", "City": "Guiyang" }, 
    { "Country": "CN", "City": "Haikou" }, 
    { "Country": "CN", "City": "Handan" }, 
    { "Country": "CN", "City": "Hangzhou" }, 
    { "Country": "CN", "City": "Hanzhong" }, 
    { "Country": "CN", "City": "Harbin" }, 
    { "Country": "CN", "City": "Hefei" }, 
    { "Country": "CN", "City": "Heihe" }, 
    { "Country": "CN", "City": "Hengshui" }, 
    { "Country": "CN", "City": "Hengyang" }, 
    { "Country": "CN", "City": "Heyuan" }, 
    { "Country": "CN", "City": "Heze" }, 
    { "Country": "CN", "City": "Hohhot" }, 
    { "Country": "CN", "City": "Huaibei" }, 
    { "Country": "CN", "City": "Huainan" }, 
    { "Country": "CN", "City": "Huangshi" }, 
    { "Country": "CN", "City": "Huizhou" }, 
    { "Country": "CN", "City": "Huzhou" }, 
    { "Country": "CN", "City": "Jiamusi" }, 
    { "Country": "CN", "City": "Jiangmen" }, 
    { "Country": "CN", "City": "Jiaozuo" }, 
    { "Country": "CN", "City": "Jiaxing" }, 
    { "Country": "CN", "City": "Jieshou" }, 
    { "Country": "CN", "City": "Jinan" }, 
    { "Country": "CN", "City": "Jingmen" }, 
    { "Country": "CN", "City": "Jinhua" }, 
    { "Country": "CN", "City": "Jining" }, 
    { "Country": "CN", "City": "Jinzhou" }, 
    { "Country": "CN", "City": "Jiujiang" }, 
    { "Country": "CN", "City": "Jixi" }, 
    { "Country": "CN", "City": "Kaifeng" }, 
    { "Country": "CN", "City": "Kunming" }, 
    { "Country": "CN", "City": "Laiwu" }, 
    { "Country": "CN", "City": "Langfang" }, 
    { "Country": "CN", "City": "Lanzhou" }, 
    { "Country": "CN", "City": "Leshan" }, 
    { "Country": "CN", "City": "Lhasa" }, 
    { "Country": "CN", "City": "Liaocheng" }, 
    { "Country": "CN", "City": "Liaoyang" }, 
    { "Country": "CN", "City": "Lijiang" }, 
    { "Country": "CN", "City": "Linfen" }, 
    { "Country": "CN", "City": "Linjiang" }, 
    { "Country": "CN", "City": "Linqing" }, 
    { "Country": "CN", "City": "Linyi" }, 
    { "Country": "CN", "City": "Lishui" }, 
    { "Country": "CN", "City": "Liuzhou" }, 
    { "Country": "CN", "City": "Luohe" }, 
    { "Country": "CN", "City": "Luoyang" }, 
    { "Country": "CN", "City": "Luzhou" }, 
    { "Country": "CN", "City": "Maoming" }, 
    { "Country": "CN", "City": "Meizhou" }, 
    { "Country": "CN", "City": "Mianyang" }, 
    { "Country": "CN", "City": "Mishan" }, 
    { "Country": "CN", "City": "Nanchang" }, 
    { "Country": "CN", "City": "Nanchong" }, 
    { "Country": "CN", "City": "Nanjing" }, 
    { "Country": "CN", "City": "Nanning" }, 
    { "Country": "CN", "City": "Nanping" }, 
    { "Country": "CN", "City": "Nantong" }, 
    { "Country": "CN", "City": "Nanyang" }, 
    { "Country": "CN", "City": "Neijiang" }, 
    { "Country": "CN", "City": "Ningbo" }, 
    { "Country": "CN", "City": "Pingdingshan" }, 
    { "Country": "CN", "City": "Pingdu" }, 
    { "Country": "CN", "City": "Pingliang" }, 
    { "Country": "CN", "City": "Pingxiang" }, 
    { "Country": "CN", "City": "Putian" }, 
    { "Country": "CN", "City": "Qingdao" }, 
    { "Country": "CN", "City": "Qinhuangdao" }, 
    { "Country": "CN", "City": "Qinzhou" }, 
    { "Country": "CN", "City": "Qiqihar" }, 
    { "Country": "CN", "City": "Quanzhou" }, 
    { "Country": "CN", "City": "Quzhou" }, 
    { "Country": "CN", "City": "Rizhao" }, 
    { "Country": "CN", "City": "Sanya" }, 
    { "Country": "CN", "City": "Shanghai" }, 
    { "Country": "CN", "City": "Shangrao" }, 
    { "Country": "CN", "City": "Shantou" }, 
    { "Country": "CN", "City": "Shaoguan" }, 
    { "Country": "CN", "City": "Shaoxing" }, 
    { "Country": "CN", "City": "Shenzhen" }, 
    { "Country": "CN", "City": "Shiyan" }, 
    { "Country": "CN", "City": "Shizuishan" }, 
    { "Country": "CN", "City": "Shuangyashan" }, 
    { "Country": "CN", "City": "Shuozhou" }, 
    { "Country": "CN", "City": "Siping" }, 
    { "Country": "CN", "City": "Suihua" }, 
    { "Country": "CN", "City": "Suining" }, 
    { "Country": "CN", "City": "Suzhou" }, 
    { "Country": "CN", "City": "Taiyuan" }, 
    { "Country": "CN", "City": "Taizhou" }, 
    { "Country": "CN", "City": "Tianjin" }, 
    { "Country": "CN", "City": "Tianshui" }, 
    { "Country": "CN", "City": "Tieling" }, 
    { "Country": "CN", "City": "Tongliao" }, 
    { "Country": "CN", "City": "Tongren" }, 
    { "Country": "CN", "City": "Weifang" }, 
    { "Country": "CN", "City": "Weihai" }, 
    { "Country": "CN", "City": "Weinan" }, 
    { "Country": "CN", "City": "Wenzhou" }, 
    { "Country": "CN", "City": "Wuhan" }, 
    { "Country": "CN", "City": "Wuhu" }, 
    { "Country": "CN", "City": "Wuwei" }, 
    { "Country": "CN", "City": "Wuxi" }, 
    { "Country": "CN", "City": "Wuzhou" }, 
    { "Country": "CN", "City": "Xiamen" }, 
    { "Country": "CN", "City": "Xiangfan" }, 
    { "Country": "CN", "City": "Xiangtan" }, 
    { "Country": "CN", "City": "Xianyang" }, 
    { "Country": "CN", "City": "Xichang" }, 
    { "Country": "CN", "City": "Xingyi" }, 
    { "Country": "CN", "City": "Xining" }, 
    { "Country": "CN", "City": "Xinxiang" }, 
    { "Country": "CN", "City": "Xinyang" }, 
    { "Country": "CN", "City": "Xinyi" }, 
    { "Country": "CN", "City": "Xinyu" }, 
    { "Country": "CN", "City": "Xinzhou" }, 
    { "Country": "CN", "City": "Xuanzhou" }, 
    { "Country": "CN", "City": "Xuchang" }, 
    { "Country": "CN", "City": "Xuzhou" }, 
    { "Country": "CN", "City": "Yancheng" }, 
    { "Country": "CN", "City": "Yangjiang" }, 
    { "Country": "CN", "City": "Yangquan" }, 
    { "Country": "CN", "City": "Yangzhou" }, 
    { "Country": "CN", "City": "Yantai" }, 
    { "Country": "CN", "City": "Yibin" }, 
    { "Country": "CN", "City": "Yichang" }, 
    { "Country": "CN", "City": "Yichun" }, 
    { "Country": "CN", "City": "Yinchuan" }, 
    { "Country": "CN", "City": "Yining" }, 
    { "Country": "CN", "City": "Yiyang" }, 
    { "Country": "CN", "City": "Yongzhou" }, 
    { "Country": "CN", "City": "Yulin" }, 
    { "Country": "CN", "City": "Yuxi" }, 
    { "Country": "CN", "City": "Zaozhuang" }, 
    { "Country": "CN", "City": "Zhangjiakou" }, 
    { "Country": "CN", "City": "Zhangzhou" }, 
    { "Country": "CN", "City": "Zhanjiang" }, 
    { "Country": "CN", "City": "Zhaoqing" }, 
    { "Country": "CN", "City": "Zhengzhou" }, 
    { "Country": "CN", "City": "Zhenjiang" }, 
    { "Country": "CN", "City": "Zhoukou" }, 
    { "Country": "CN", "City": "Zhuhai" }, 
    { "Country": "CN", "City": "Zhuozhou" }, 
    { "Country": "CN", "City": "Zibo" }, 
    { "Country": "CN", "City": "Zigong" }, 
    { "Country": "CN", "City": "Zunyi" }, 
    { "Country": "CO", "City": "Armenia" }, 
    { "Country": "CO", "City": "Barrancabermeja" }, 
    { "Country": "CO", "City": "Barranquilla" }, 
    { "Country": "CO", "City": "Bello" }, 
    { "Country": "CO", "City": "Bucaramanga" }, 
    { "Country": "CO", "City": "Buenaventura" }, 
    { "Country": "CO", "City": "Cartagena" }, 
    { "Country": "CO", "City": "Cartago" }, 
    { "Country": "CO", "City": "Cienaga" }, 
    { "Country": "CO", "City": "Duitama" }, 
    { "Country": "CO", "City": "Ibague" }, 
    { "Country": "CO", "City": "Ipiales" }, 
    { "Country": "CO", "City": "Manizales" }, 
    { "Country": "CO", "City": "Neiva" }, 
    { "Country": "CO", "City": "Pasto" }, 
    { "Country": "CO", "City": "Pereira" }, 
    { "Country": "CO", "City": "Popayan" }, 
    { "Country": "CO", "City": "Riohacha" }, 
    { "Country": "CO", "City": "Sincelejo" }, 
    { "Country": "CO", "City": "Socorro" }, 
    { "Country": "CO", "City": "Sogamoso" }, 
    { "Country": "CO", "City": "Tame" }, 
    { "Country": "CO", "City": "Tunja" }, 
    { "Country": "CO", "City": "Valledupar" }, 
    { "Country": "CO", "City": "Villavicencio" }, 
    { "Country": "CO", "City": "Yopal" }, 
    { "Country": "KM", "City": "Moroni" }, 
    { "Country": "CG", "City": "Djambala" }, 
    { "Country": "CD", "City": "Kinshasa" }, 
    { "Country": "CD", "City": "Yangambi" }, 
    { "Country": "CR", "City": "Alajuela" }, 
    { "Country": "CR", "City": "Heredia" }, 
    { "Country": "CR", "City": "Liberia" }, 
    { "Country": "CR", "City": "Puntarenas" }, 
    { "Country": "CR", "City": "Quesada" }, 
    { "Country": "CI", "City": "Abidjan" }, 
    { "Country": "CI", "City": "San-Pedro" }, 
    { "Country": "HR", "City": "Bjelovar" }, 
    { "Country": "HR", "City": "Dubrovnik" }, 
    { "Country": "HR", "City": "Koprivnica" }, 
    { "Country": "HR", "City": "Osijek" }, 
    { "Country": "HR", "City": "Pula" }, 
    { "Country": "HR", "City": "Rijeka" }, 
    { "Country": "HR", "City": "Sisak" }, 
    { "Country": "HR", "City": "Split" }, 
    { "Country": "HR", "City": "Virovitica" }, 
    { "Country": "HR", "City": "Vukovar" }, 
    { "Country": "HR", "City": "Zadar" }, 
    { "Country": "HR", "City": "Zagreb" }, 
    { "Country": "CW", "City": "Willemstad" }, 
    { "Country": "CY", "City": "Nicosia" }, 
    { "Country": "CZ", "City": "Brno" }, 
    { "Country": "CZ", "City": "Jihlava" }, 
    { "Country": "CZ", "City": "Liberec" }, 
    { "Country": "CZ", "City": "Olomouc" }, 
    { "Country": "CZ", "City": "Ostrava" }, 
    { "Country": "CZ", "City": "Pardubice" }, 
    { "Country": "CZ", "City": "Prague" }, 
    { "Country": "DM", "City": "Roseau" }, 
    { "Country": "DO", "City": "Azua" }, 
    { "Country": "DO", "City": "Bavaro" }, 
    { "Country": "DO", "City": "Bonao" }, 
    { "Country": "DO", "City": "Cotui" }, 
    { "Country": "DO", "City": "Dajabon" }, 
    { "Country": "DO", "City": "Moca" }, 
    { "Country": "EC", "City": "Ambato" }, 
    { "Country": "EC", "City": "Babahoyo" }, 
    { "Country": "EC", "City": "Cayambe" }, 
    { "Country": "EC", "City": "Cuenca" }, 
    { "Country": "EC", "City": "Esmeraldas" }, 
    { "Country": "EC", "City": "Guayaquil" }, 
    { "Country": "EC", "City": "Ibarra" }, 
    { "Country": "EC", "City": "Jipijapa" }, 
    { "Country": "EC", "City": "Latacunga" }, 
    { "Country": "EC", "City": "Loja" }, 
    { "Country": "EC", "City": "Machala" }, 
    { "Country": "EC", "City": "Manta" }, 
    { "Country": "EC", "City": "Milagro" }, 
    { "Country": "EC", "City": "Portoviejo" }, 
    { "Country": "EC", "City": "Puyo" }, 
    { "Country": "EC", "City": "Quito" }, 
    { "Country": "EC", "City": "Riobamba" }, 
    { "Country": "EC", "City": "Salinas" }, 
    { "Country": "EC", "City": "Tena" }, 
    { "Country": "EG", "City": "Aswan" }, 
    { "Country": "EG", "City": "Cairo" }, 
    { "Country": "EG", "City": "Damanhur" }, 
    { "Country": "EG", "City": "Hurghada" }, 
    { "Country": "EG", "City": "Ismailia" }, 
    { "Country": "EG", "City": "Luxor" }, 
    { "Country": "EG", "City": "Sohag" }, 
    { "Country": "EG", "City": "Suez" }, 
    { "Country": "EG", "City": "Tanta" }, 
    { "Country": "EG", "City": "Zagazig" }, 
    { "Country": "SV", "City": "Ahuachapan" }, 
    { "Country": "SV", "City": "Chalatenango" }, 
    { "Country": "SV", "City": "Sonsonate" }, 
    { "Country": "SV", "City": "Usulutan" }, 
    { "Country": "GQ", "City": "Malabo" }, 
    { "Country": "EE", "City": "Haapsalu" }, 
    { "Country": "EE", "City": "Tallinn" }, 
    { "Country": "FJ", "City": "Suva" }, 
    { "Country": "FI", "City": "Helsinki" }, 
    { "Country": "FI", "City": "Lappeenranta" }, 
    { "Country": "FI", "City": "Pori" }, 
    { "Country": "FI", "City": "Tampere" }, 
    { "Country": "FR", "City": "Amiens" }, 
    { "Country": "FR", "City": "Angers" }, 
    { "Country": "FR", "City": "Arras" }, 
    { "Country": "FR", "City": "Auxerre" }, 
    { "Country": "FR", "City": "Bordeaux" }, 
    { "Country": "FR", "City": "Bourges" }, 
    { "Country": "FR", "City": "Brest" }, 
    { "Country": "FR", "City": "Caen" }, 
    { "Country": "FR", "City": "Calais" }, 
    { "Country": "FR", "City": "Clermont-Ferrand" }, 
    { "Country": "FR", "City": "Dijon" }, 
    { "Country": "FR", "City": "Grenoble" }, 
    { "Country": "FR", "City": "Lille" }, 
    { "Country": "FR", "City": "Limoges" }, 
    { "Country": "FR", "City": "Lorient" }, 
    { "Country": "FR", "City": "Lyon" }, 
    { "Country": "FR", "City": "Marseille" }, 
    { "Country": "FR", "City": "Melun" }, 
    { "Country": "FR", "City": "Metz" }, 
    { "Country": "FR", "City": "Montpellier" }, 
    { "Country": "FR", "City": "Mulhouse" }, 
    { "Country": "FR", "City": "Nancy" }, 
    { "Country": "FR", "City": "Nantes" }, 
    { "Country": "FR", "City": "Nevers" }, 
    { "Country": "FR", "City": "Nice" }, 
    { "Country": "FR", "City": "Paris" }, 
    { "Country": "FR", "City": "Reims" }, 
    { "Country": "FR", "City": "Rennes" }, 
    { "Country": "FR", "City": "Roanne" }, 
    { "Country": "FR", "City": "Rouen" }, 
    { "Country": "FR", "City": "Strasbourg" }, 
    { "Country": "FR", "City": "Toulon" }, 
    { "Country": "FR", "City": "Toulouse" }, 
    { "Country": "FR", "City": "Tours" }, 
    { "Country": "FR", "City": "Troyes" }, 
    { "Country": "FR", "City": "Versailles" }, 
    { "Country": "FR", "City": "Vichy" }, 
    { "Country": "GF", "City": "Cayenne" }, 
    { "Country": "PF", "City": "Papeete" }, 
    { "Country": "GA", "City": "Libreville" }, 
    { "Country": "GM", "City": "Banjul" }, 
    { "Country": "GE", "City": "Batumi" }, 
    { "Country": "GE", "City": "Kutaisi" }, 
    { "Country": "GE", "City": "Tbilisi" }, 
    { "Country": "GE", "City": "Telavi" }, 
    { "Country": "GE", "City": "Zugdidi" }, 
    { "Country": "DE", "City": "Augsburg" }, 
    { "Country": "DE", "City": "Berlin" }, 
    { "Country": "DE", "City": "Bielefeld" }, 
    { "Country": "DE", "City": "Bonn" }, 
    { "Country": "DE", "City": "Bremen" }, 
    { "Country": "DE", "City": "Bremerhaven" }, 
    { "Country": "DE", "City": "Chemnitz" }, 
    { "Country": "DE", "City": "Cologne" }, 
    { "Country": "DE", "City": "Dortmund" }, 
    { "Country": "DE", "City": "Dresden" }, 
    { "Country": "DE", "City": "Duisburg" }, 
    { "Country": "DE", "City": "Essen" }, 
    { "Country": "DE", "City": "Freiburg" }, 
    { "Country": "DE", "City": "Gera" }, 
    { "Country": "DE", "City": "Hamburg" }, 
    { "Country": "DE", "City": "Heidelberg" }, 
    { "Country": "DE", "City": "Karlsruhe" }, 
    { "Country": "DE", "City": "Kassel" }, 
    { "Country": "DE", "City": "Kiel" }, 
    { "Country": "DE", "City": "Leipzig" }, 
    { "Country": "DE", "City": "Mainz" }, 
    { "Country": "DE", "City": "Mannheim" }, 
    { "Country": "DE", "City": "Munich" }, 
    { "Country": "DE", "City": "Oldenburg" }, 
    { "Country": "DE", "City": "Stuttgart" }, 
    { "Country": "DE", "City": "Wuppertal" }, 
    { "Country": "DK", "City": "Copenhagen" }, 
    { "Country": "HK", "City": "Victoria" }, 
    { "Country": "GH", "City": "Accra" }, 
    { "Country": "GH", "City": "Tamale" }, 
    { "Country": "GR", "City": "Athens" }, 
    { "Country": "GR", "City": "Kalamata" }, 
    { "Country": "GR", "City": "Katerini" }, 
    { "Country": "GR", "City": "Kavala" }, 
    { "Country": "GR", "City": "Larissa" }, 
    { "Country": "GR", "City": "Thessaloniki" }, 
    { "Country": "GR", "City": "Tripoli" }, 
    { "Country": "GR", "City": "Volos" }, 
    { "Country": "GR", "City": "Xanthi" }, 
    { "Country": "GT", "City": "Chiquimula" }, 
    { "Country": "GT", "City": "Coban" }, 
    { "Country": "GT", "City": "Jalapa" }, 
    { "Country": "GT", "City": "Quetzaltenango" }, 
    { "Country": "GT", "City": "Zacapa" }, 
    { "Country": "GN", "City": "Conakry" }, 
    { "Country": "HT", "City": "Port-au-Prince" }, 
    { "Country": "HN", "City": "Comayagua" }, 
    { "Country": "HN", "City": "Tegucigalpa" }, 
    { "Country": "HU", "City": "Budapest" }, 
    { "Country": "HU", "City": "Debrecen" }, 
    { "Country": "HU", "City": "Miskolc" }, 
    { "Country": "HU", "City": "Nagykanizsa" }, 
    { "Country": "HU", "City": "Nyiregyhaza" }, 
    { "Country": "HU", "City": "Sopron" }, 
    { "Country": "HU", "City": "Szeged" }, 
    { "Country": "HU", "City": "Szolnok" }, 
    { "Country": "HU", "City": "Szombathely" }, 
    { "Country": "HU", "City": "Zalaegerszeg" }, 
    { "Country": "IN", "City": "Ahmedabad" }, 
    { "Country": "IN", "City": "Ahmednagar" }, 
    { "Country": "IN", "City": "Ajmer" }, 
    { "Country": "IN", "City": "Akola" }, 
    { "Country": "IN", "City": "Alappuzha" }, 
    { "Country": "IN", "City": "Allahabad" }, 
    { "Country": "IN", "City": "Ambala" }, 
    { "Country": "IN", "City": "Amritsar" }, 
    { "Country": "IN", "City": "Aurangabad" }, 
    { "Country": "IN", "City": "Barddhaman" }, 
    { "Country": "IN", "City": "Bareilly" }, 
    { "Country": "IN", "City": "Belgaum" }, 
    { "Country": "IN", "City": "Bhilwara" }, 
    { "Country": "IN", "City": "Bhiwandi" }, 
    { "Country": "IN", "City": "Bhopal" }, 
    { "Country": "IN", "City": "Chandigarh" }, 
    { "Country": "IN", "City": "Chennai" }, 
    { "Country": "IN", "City": "Coimbatore" }, 
    { "Country": "IN", "City": "Cuttack" }, 
    { "Country": "IN", "City": "Delhi" }, 
    { "Country": "IN", "City": "Dhanbad" }, 
    { "Country": "IN", "City": "Faridabad" }, 
    { "Country": "IN", "City": "Gandhinagar" }, 
    { "Country": "IN", "City": "Ghaziabad" }, 
    { "Country": "IN", "City": "Gulbarga" }, 
    { "Country": "IN", "City": "Guntur" }, 
    { "Country": "IN", "City": "Gurgaon" }, 
    { "Country": "IN", "City": "Guwahati" }, 
    { "Country": "IN", "City": "Hapur" }, 
    { "Country": "IN", "City": "Hoshiarpur" }, 
    { "Country": "IN", "City": "Hubli" }, 
    { "Country": "IN", "City": "Hyderabad" }, 
    { "Country": "IN", "City": "Imphal" }, 
    { "Country": "IN", "City": "Indore" }, 
    { "Country": "IN", "City": "Jaipur" }, 
    { "Country": "IN", "City": "Jammu" }, 
    { "Country": "IN", "City": "Jhansi" }, 
    { "Country": "IN", "City": "Jodhpur" }, 
    { "Country": "IN", "City": "Kalyan" }, 
    { "Country": "IN", "City": "Kanpur" }, 
    { "Country": "IN", "City": "Kohima" }, 
    { "Country": "IN", "City": "Kolhapur" }, 
    { "Country": "IN", "City": "Kolkata" }, 
    { "Country": "IN", "City": "Kollam" }, 
    { "Country": "IN", "City": "Kota" }, 
    { "Country": "IN", "City": "Kozhikode" }, 
    { "Country": "IN", "City": "Kumbakonam" }, 
    { "Country": "IN", "City": "Lucknow" }, 
    { "Country": "IN", "City": "Ludhiana" }, 
    { "Country": "IN", "City": "Madurai" }, 
    { "Country": "IN", "City": "Mangalore" }, 
    { "Country": "IN", "City": "Medinipur" }, 
    { "Country": "IN", "City": "Meerut" }, 
    { "Country": "IN", "City": "Mumbai" }, 
    { "Country": "IN", "City": "Muzaffarpur" }, 
    { "Country": "IN", "City": "Mysore" }, 
    { "Country": "IN", "City": "Nagercoil" }, 
    { "Country": "IN", "City": "Nagpur" }, 
    { "Country": "IN", "City": "Nellore" }, 
    { "Country": "IN", "City": "Ongole" }, 
    { "Country": "IN", "City": "Panipat" }, 
    { "Country": "IN", "City": "Patna" }, 
    { "Country": "IN", "City": "Pune" }, 
    { "Country": "IN", "City": "Raichur" }, 
    { "Country": "IN", "City": "Raipur" }, 
    { "Country": "IN", "City": "Rajahmundry" }, 
    { "Country": "IN", "City": "Ranchi" }, 
    { "Country": "IN", "City": "Raurkela" }, 
    { "Country": "IN", "City": "Saharanpur" }, 
    { "Country": "IN", "City": "Siliguri" }, 
    { "Country": "IN", "City": "Silvassa" }, 
    { "Country": "IN", "City": "Sonipat" }, 
    { "Country": "IN", "City": "Thiruvananthapuram" }, 
    { "Country": "IN", "City": "Tiruppur" }, 
    { "Country": "IN", "City": "Ujjain" }, 
    { "Country": "IN", "City": "Vadodara" }, 
    { "Country": "IN", "City": "Varanasi" }, 
    { "Country": "IN", "City": "Vellore" }, 
    { "Country": "IN", "City": "Vijayawada" }, 
    { "Country": "ID", "City": "Balikpapan" }, 
    { "Country": "ID", "City": "Bandung" }, 
    { "Country": "ID", "City": "Banyuwangi" }, 
    { "Country": "ID", "City": "Bekasi" }, 
    { "Country": "ID", "City": "Blitar" }, 
    { "Country": "ID", "City": "Bogor" }, 
    { "Country": "ID", "City": "Cilacap" }, 
    { "Country": "ID", "City": "Cirebon" }, 
    { "Country": "ID", "City": "Denpasar" }, 
    { "Country": "ID", "City": "Gorontalo" }, 
    { "Country": "ID", "City": "Indramayu" }, 
    { "Country": "ID", "City": "Jakarta" }, 
    { "Country": "ID", "City": "Jayapura" }, 
    { "Country": "ID", "City": "Jember" }, 
    { "Country": "ID", "City": "Kediri" }, 
    { "Country": "ID", "City": "Kupang" }, 
    { "Country": "ID", "City": "Magelang" }, 
    { "Country": "ID", "City": "Majene" }, 
    { "Country": "ID", "City": "Malang" }, 
    { "Country": "ID", "City": "Manado" }, 
    { "Country": "ID", "City": "Manokwari" }, 
    { "Country": "ID", "City": "Martapura" }, 
    { "Country": "ID", "City": "Mataram" }, 
    { "Country": "ID", "City": "Medan" }, 
    { "Country": "ID", "City": "Padang" }, 
    { "Country": "ID", "City": "Palangkaraya" }, 
    { "Country": "ID", "City": "Palembang" }, 
    { "Country": "ID", "City": "Palopo" }, 
    { "Country": "ID", "City": "Palu" }, 
    { "Country": "ID", "City": "Parepare" }, 
    { "Country": "ID", "City": "Pasuruan" }, 
    { "Country": "ID", "City": "Pati" }, 
    { "Country": "ID", "City": "Pekanbaru" }, 
    { "Country": "ID", "City": "Pontianak" }, 
    { "Country": "ID", "City": "Salatiga" }, 
    { "Country": "ID", "City": "Samarinda" }, 
    { "Country": "ID", "City": "Semarang" }, 
    { "Country": "ID", "City": "Serang" }, 
    { "Country": "ID", "City": "Sorong" }, 
    { "Country": "ID", "City": "Surabaya" }, 
    { "Country": "ID", "City": "Surakarta" }, 
    { "Country": "ID", "City": "Tarakan" }, 
    { "Country": "ID", "City": "Tasikmalaya" }, 
    { "Country": "ID", "City": "Tegal" }, 
    { "Country": "ID", "City": "Ternate" }, 
    { "Country": "ID", "City": "Timika" }, 
    { "Country": "ID", "City": "Tuban" }, 
    { "Country": "ID", "City": "Yogyakarta" }, 
    { "Country": "IR", "City": "Arak" }, 
    { "Country": "IR", "City": "Ilam" }, 
    { "Country": "IR", "City": "Isfahan" }, 
    { "Country": "IR", "City": "Mashhad" }, 
    { "Country": "IR", "City": "Qom" }, 
    { "Country": "IR", "City": "Rasht" }, 
    { "Country": "IR", "City": "Tehran" }, 
    { "Country": "IR", "City": "Yazd" }, 
    { "Country": "IQ", "City": "Baghdad" }, 
    { "Country": "IQ", "City": "Baqubah" }, 
    { "Country": "IQ", "City": "Dahuk" }, 
    { "Country": "IQ", "City": "Karbala" }, 
    { "Country": "IQ", "City": "Kirkuk" }, 
    { "Country": "IQ", "City": "Mosul" }, 
    { "Country": "IQ", "City": "Samarra" }, 
    { "Country": "IQ", "City": "Tikrit" }, 
    { "Country": "IE", "City": "Drogheda" }, 
    { "Country": "IE", "City": "Dublin" }, 
    { "Country": "IE", "City": "Galway" }, 
    { "Country": "IE", "City": "Limerick" }, 
    { "Country": "IE", "City": "Nenagh" }, 
    { "Country": "IM", "City": "Douglas" }, 
    { "Country": "IL", "City": "Haifa" }, 
    { "Country": "IL", "City": "Jerusalem" }, 
    { "Country": "IT", "City": "Ancona" }, 
    { "Country": "IT", "City": "Aosta" }, 
    { "Country": "IT", "City": "Bari" }, 
    { "Country": "IT", "City": "Bergamo" }, 
    { "Country": "IT", "City": "Bologna" }, 
    { "Country": "IT", "City": "Brindisi" }, 
    { "Country": "IT", "City": "Cagliari" }, 
    { "Country": "IT", "City": "Caserta" }, 
    { "Country": "IT", "City": "Catania" }, 
    { "Country": "IT", "City": "Civitavecchia" }, 
    { "Country": "IT", "City": "Florence" }, 
    { "Country": "IT", "City": "Foggia" }, 
    { "Country": "IT", "City": "Genoa" }, 
    { "Country": "IT", "City": "Lecce" }, 
    { "Country": "IT", "City": "Livorno" }, 
    { "Country": "IT", "City": "Milan" }, 
    { "Country": "IT", "City": "Modena" }, 
    { "Country": "IT", "City": "Naples" }, 
    { "Country": "IT", "City": "Novara" }, 
    { "Country": "IT", "City": "Palermo" }, 
    { "Country": "IT", "City": "Pescara" }, 
    { "Country": "IT", "City": "Ragusa" }, 
    { "Country": "IT", "City": "Rome" }, 
    { "Country": "IT", "City": "Salerno" }, 
    { "Country": "IT", "City": "Sassari" }, 
    { "Country": "IT", "City": "Taranto" }, 
    { "Country": "IT", "City": "Trieste" }, 
    { "Country": "IT", "City": "Turin" }, 
    { "Country": "IT", "City": "Udine" }, 
    { "Country": "IT", "City": "Verona" }, 
    { "Country": "JM", "City": "Falmouth" }, 
    { "Country": "JM", "City": "Kingston" }, 
    { "Country": "JM", "City": "Lucea" }, 
    { "Country": "JP", "City": "Chiba" }, 
    { "Country": "JP", "City": "Fukuoka" }, 
    { "Country": "JP", "City": "Fukushima" }, 
    { "Country": "JP", "City": "Hamamatsu" }, 
    { "Country": "JP", "City": "Kanazawa" }, 
    { "Country": "JP", "City": "Kobe" }, 
    { "Country": "JP", "City": "Kochi" }, 
    { "Country": "JP", "City": "Kumamoto" }, 
    { "Country": "JP", "City": "Kyoto" }, 
    { "Country": "JP", "City": "Maebashi" }, 
    { "Country": "JP", "City": "Matsuyama" }, 
    { "Country": "JP", "City": "Mito" }, 
    { "Country": "JP", "City": "Nagoya" }, 
    { "Country": "JP", "City": "Nara" }, 
    { "Country": "JP", "City": "Okayama" }, 
    { "Country": "JP", "City": "Osaka" }, 
    { "Country": "JP", "City": "Saitama" }, 
    { "Country": "JP", "City": "Sapporo" }, 
    { "Country": "JP", "City": "Shizuoka" }, 
    { "Country": "JP", "City": "Takamatsu" }, 
    { "Country": "JP", "City": "Tokyo" }, 
    { "Country": "JP", "City": "Toyama" }, 
    { "Country": "JP", "City": "Utsunomiya" }, 
    { "Country": "JP", "City": "Yamagata" }, 
    { "Country": "JP", "City": "Yokohama" }, 
    { "Country": "JO", "City": "Amman" }, 
    { "Country": "JO", "City": "Irbid" }, 
    { "Country": "KZ", "City": "Almaty" }, 
    { "Country": "KZ", "City": "Atyrau" }, 
    { "Country": "KZ", "City": "Ekibastuz" }, 
    { "Country": "KZ", "City": "Khromtau" }, 
    { "Country": "KZ", "City": "Kokshetau" }, 
    { "Country": "KZ", "City": "Pavlodar" }, 
    { "Country": "KZ", "City": "Ridder" }, 
    { "Country": "KZ", "City": "Semey" }, 
    { "Country": "KZ", "City": "Shymkent" }, 
    { "Country": "KZ", "City": "Taraz" }, 
    { "Country": "KZ", "City": "Temirtau" }, 
    { "Country": "KE", "City": "Eldoret" }, 
    { "Country": "KE", "City": "Embu" }, 
    { "Country": "KE", "City": "Kajiado" }, 
    { "Country": "KE", "City": "Kisumu" }, 
    { "Country": "KE", "City": "Mombasa" }, 
    { "Country": "KE", "City": "Nairobi" }, 
    { "Country": "KE", "City": "Nakuru" }, 
    { "Country": "KR", "City": "Andong" }, 
    { "Country": "KR", "City": "Busan" }, 
    { "Country": "KR", "City": "Changwon" }, 
    { "Country": "KR", "City": "Chuncheon" }, 
    { "Country": "KR", "City": "Daegu" }, 
    { "Country": "KR", "City": "Daejeon" }, 
    { "Country": "KR", "City": "Gangneung" }, 
    { "Country": "KR", "City": "Gunsan" }, 
    { "Country": "KR", "City": "Gwangju" }, 
    { "Country": "KR", "City": "Gyeongju" }, 
    { "Country": "KR", "City": "Hongseong" }, 
    { "Country": "KR", "City": "Iksan" }, 
    { "Country": "KR", "City": "Incheon" }, 
    { "Country": "KR", "City": "Jeonju" }, 
    { "Country": "KR", "City": "Mokpo" }, 
    { "Country": "KR", "City": "Muan" }, 
    { "Country": "KR", "City": "Pohang" }, 
    { "Country": "KR", "City": "Sejong" }, 
    { "Country": "KR", "City": "Seoul" }, 
    { "Country": "KR", "City": "Sokcho" }, 
    { "Country": "KR", "City": "Suwon" }, 
    { "Country": "KR", "City": "Ulsan" }, 
    { "Country": "KR", "City": "Wonju" }, 
    { "Country": "KR", "City": "Yeosu" }, 
    { "Country": "KG", "City": "Bishkek" }, 
    { "Country": "KG", "City": "Osh" }, 
    { "Country": "KW", "City": "Kuwait" }, 
    { "Country": "LA", "City": "Vientiane" }, 
    { "Country": "LV", "City": "Jelgava" }, 
    { "Country": "LV", "City": "Riga" }, 
    { "Country": "LB", "City": "Beirut" }, 
    { "Country": "LS", "City": "Maseru" }, 
    { "Country": "LR", "City": "Monrovia" }, 
    { "Country": "LT", "City": "Kaunas" }, 
    { "Country": "LT", "City": "Pasvalys" }, 
    { "Country": "LT", "City": "Raseiniai" }, 
    { "Country": "LT", "City": "Vilnius" }, 
    { "Country": "MK", "City": "Bitola" }, 
    { "Country": "MK", "City": "Bogdanci" }, 
    { "Country": "MK", "City": "Debar" }, 
    { "Country": "MK", "City": "Delcevo" }, 
    { "Country": "MK", "City": "Gevgelija" }, 
    { "Country": "MK", "City": "Gostivar" }, 
    { "Country": "MK", "City": "Kavadarci" }, 
    { "Country": "MK", "City": "Kumanovo" }, 
    { "Country": "MK", "City": "Negotino" }, 
    { "Country": "MK", "City": "Prilep" }, 
    { "Country": "MK", "City": "Radovis" }, 
    { "Country": "MK", "City": "Skopje" }, 
    { "Country": "MK", "City": "Struga" }, 
    { "Country": "MK", "City": "Strumica" }, 
    { "Country": "MK", "City": "Tetovo" }, 
    { "Country": "MG", "City": "Antananarivo" }, 
    { "Country": "MG", "City": "Mahajanga" }, 
    { "Country": "MG", "City": "Toamasina" }, 
    { "Country": "MW", "City": "Blantyre" }, 
    { "Country": "MW", "City": "Lilongwe" }, 
    { "Country": "MY", "City": "Butterworth" }, 
    { "Country": "MY", "City": "Ipoh" }, 
    { "Country": "MY", "City": "Kuantan" }, 
    { "Country": "MY", "City": "Kuching" }, 
    { "Country": "MY", "City": "Malacca" }, 
    { "Country": "MY", "City": "Seremban" }, 
    { "Country": "MY", "City": "Sibu" }, 
    { "Country": "ML", "City": "Bamako" }, 
    { "Country": "ML", "City": "Koulikoro" }, 
    { "Country": "MT", "City": "Imsida" }, 
    { "Country": "MT", "City": "Luqa" }, 
    { "Country": "MT", "City": "Naxxar" }, 
    { "Country": "MT", "City": "Paola" }, 
    { "Country": "MT", "City": "Sliema" }, 
    { "Country": "MQ", "City": "Fort-de-France" }, 
    { "Country": "MR", "City": "Kiffa" }, 
    { "Country": "MR", "City": "Nouakchott" }, 
    { "Country": "MU", "City": "Curepipe" }, 
    { "Country": "MX", "City": "Aguascalientes" }, 
    { "Country": "MX", "City": "Campeche" }, 
    { "Country": "MX", "City": "Celaya" }, 
    { "Country": "MX", "City": "Chetumal" }, 
    { "Country": "MX", "City": "Chilpancingo" }, 
    { "Country": "MX", "City": "Coatzacoalcos" }, 
    { "Country": "MX", "City": "Colima" }, 
    { "Country": "MX", "City": "Cuauhtemoc" }, 
    { "Country": "MX", "City": "Cuernavaca" }, 
    { "Country": "MX", "City": "Durango" }, 
    { "Country": "MX", "City": "Ensenada" }, 
    { "Country": "MX", "City": "Fresnillo" }, 
    { "Country": "MX", "City": "Guadalajara" }, 
    { "Country": "MX", "City": "Guamuchil" }, 
    { "Country": "MX", "City": "Guasave" }, 
    { "Country": "MX", "City": "Guaymas" }, 
    { "Country": "MX", "City": "Hermosillo" }, 
    { "Country": "MX", "City": "Irapuato" }, 
    { "Country": "MX", "City": "Manzanillo" }, 
    { "Country": "MX", "City": "Mexicali" }, 
    { "Country": "MX", "City": "Monclova" }, 
    { "Country": "MX", "City": "Monterrey" }, 
    { "Country": "MX", "City": "Morelia" }, 
    { "Country": "MX", "City": "Nogales" }, 
    { "Country": "MX", "City": "Orizaba" }, 
    { "Country": "MX", "City": "Pachuca" }, 
    { "Country": "MX", "City": "Puebla" }, 
    { "Country": "MX", "City": "Reynosa" }, 
    { "Country": "MX", "City": "Salamanca" }, 
    { "Country": "MX", "City": "Saltillo" }, 
    { "Country": "MX", "City": "Tampico" }, 
    { "Country": "MX", "City": "Tapachula" }, 
    { "Country": "MX", "City": "Tepic" }, 
    { "Country": "MX", "City": "Tijuana" }, 
    { "Country": "MX", "City": "Toluca" }, 
    { "Country": "MX", "City": "Torreon" }, 
    { "Country": "MX", "City": "Uruapan" }, 
    { "Country": "MX", "City": "Veracruz" }, 
    { "Country": "MX", "City": "Villahermosa" }, 
    { "Country": "MX", "City": "Xalapa" }, 
    { "Country": "MX", "City": "Zamora" }, 
    { "Country": "MX", "City": "Zumpango" }, 
    { "Country": "FM", "City": "Tofol" }, 
    { "Country": "MD", "City": "Briceni" }, 
    { "Country": "MD", "City": "Cahul" }, 
    { "Country": "MD", "City": "Calarasi" }, 
    { "Country": "MD", "City": "Cantemir" }, 
    { "Country": "MD", "City": "Chisinau" }, 
    { "Country": "MD", "City": "Cimislia" }, 
    { "Country": "MD", "City": "Comrat" }, 
    { "Country": "MD", "City": "Donduseni" }, 
    { "Country": "MD", "City": "Drochia" }, 
    { "Country": "MD", "City": "Floresti" }, 
    { "Country": "MD", "City": "Glodeni" }, 
    { "Country": "MD", "City": "Ialoveni" }, 
    { "Country": "MD", "City": "Nisporeni" }, 
    { "Country": "MD", "City": "Ocnita" }, 
    { "Country": "MD", "City": "Singerei" }, 
    { "Country": "MD", "City": "Soroca" }, 
    { "Country": "MD", "City": "Straseni" }, 
    { "Country": "MD", "City": "Taraclia" }, 
    { "Country": "MD", "City": "Telenesti" }, 
    { "Country": "MD", "City": "Tiraspol" }, 
    { "Country": "MD", "City": "Ungheni" }, 
    { "Country": "MN", "City": "Dalandzadgad" }, 
    { "Country": "ME", "City": "Bar" }, 
    { "Country": "ME", "City": "Budva" }, 
    { "Country": "ME", "City": "Kotor" }, 
    { "Country": "ME", "City": "Plav" }, 
    { "Country": "ME", "City": "Podgorica" }, 
    { "Country": "MA", "City": "Agadir" }, 
    { "Country": "MA", "City": "Casablanca" }, 
    { "Country": "MA", "City": "Kenitra" }, 
    { "Country": "MA", "City": "Marrakesh" }, 
    { "Country": "MA", "City": "Meknes" }, 
    { "Country": "MA", "City": "Oujda" }, 
    { "Country": "MA", "City": "Rabat" }, 
    { "Country": "MA", "City": "Settat" }, 
    { "Country": "MA", "City": "Tangier" }, 
    { "Country": "MZ", "City": "Maputo" }, 
    { "Country": "MZ", "City": "Matola" }, 
    { "Country": "MZ", "City": "Nampula" }, 
    { "Country": "MM", "City": "Mandalay" }, 
    { "Country": "MM", "City": "Ye" }, 
    { "Country": "NA", "City": "Grootfontein" }, 
    { "Country": "NA", "City": "Mariental" }, 
    { "Country": "NA", "City": "Ongwediva" }, 
    { "Country": "NA", "City": "Oshakati" }, 
    { "Country": "NA", "City": "Otjiwarongo" }, 
    { "Country": "NA", "City": "Rundu" }, 
    { "Country": "NA", "City": "Swakopmund" }, 
    { "Country": "NA", "City": "Windhoek" }, 
    { "Country": "NP", "City": "Biratnagar" }, 
    { "Country": "NP", "City": "Hetauda" }, 
    { "Country": "NP", "City": "Kathmandu" }, 
    { "Country": "NP", "City": "Pokhara" }, 
    { "Country": "NL", "City": "Amsterdam" }, 
    { "Country": "NL", "City": "Eindhoven" }, 
    { "Country": "NL", "City": "Groningen" }, 
    { "Country": "NL", "City": "Haarlem" }, 
    { "Country": "NL", "City": "Maastricht" }, 
    { "Country": "NL", "City": "Rotterdam" }, 
    { "Country": "NL", "City": "Utrecht" }, 
    { "Country": "NC", "City": "Noumea" }, 
    { "Country": "NC", "City": "We" }, 
    { "Country": "NZ", "City": "Auckland" }, 
    { "Country": "NZ", "City": "Christchurch" }, 
    { "Country": "NZ", "City": "Invercargill" }, 
    { "Country": "NZ", "City": "Nelson" }, 
    { "Country": "NZ", "City": "Tauranga" }, 
    { "Country": "NZ", "City": "Wellington" }, 
    { "Country": "NI", "City": "Bluefields" }, 
    { "Country": "NI", "City": "Boaco" }, 
    { "Country": "NI", "City": "Chinandega" }, 
    { "Country": "NI", "City": "Esteli" }, 
    { "Country": "NI", "City": "Jinotega" }, 
    { "Country": "NI", "City": "Managua" }, 
    { "Country": "NI", "City": "Masaya" }, 
    { "Country": "NI", "City": "Ocotal" }, 
    { "Country": "NI", "City": "Rivas" }, 
    { "Country": "NE", "City": "Niamey" }, 
    { "Country": "NG", "City": "Akure" }, 
    { "Country": "NG", "City": "Calabar" }, 
    { "Country": "NG", "City": "Enugu" }, 
    { "Country": "NG", "City": "Ibadan" }, 
    { "Country": "NG", "City": "Ikeja" }, 
    { "Country": "NG", "City": "Lagos" }, 
    { "Country": "NG", "City": "Uyo" }, 
    { "Country": "NG", "City": "Warri" }, 
    { "Country": "NO", "City": "Bergen" }, 
    { "Country": "NO", "City": "Hamar" }, 
    { "Country": "NO", "City": "Oslo" }, 
    { "Country": "NO", "City": "Stavanger" }, 
    { "Country": "OM", "City": "Muscat" }, 
    { "Country": "OM", "City": "Salalah" }, 
    { "Country": "PK", "City": "Abbottabad" }, 
    { "Country": "PK", "City": "Bahawalpur" }, 
    { "Country": "PK", "City": "Chiniot" }, 
    { "Country": "PK", "City": "Faisalabad" }, 
    { "Country": "PK", "City": "Gilgit" }, 
    { "Country": "PK", "City": "Gujranwala" }, 
    { "Country": "PK", "City": "Gujrat" }, 
    { "Country": "PK", "City": "Islamabad" }, 
    { "Country": "PK", "City": "Karachi" }, 
    { "Country": "PK", "City": "Kasur" }, 
    { "Country": "PK", "City": "Kohat" }, 
    { "Country": "PK", "City": "Lahore" }, 
    { "Country": "PK", "City": "Larkana" }, 
    { "Country": "PK", "City": "Mansehra" }, 
    { "Country": "PK", "City": "Mardan" }, 
    { "Country": "PK", "City": "Multan" }, 
    { "Country": "PK", "City": "Okara" }, 
    { "Country": "PK", "City": "Peshawar" }, 
    { "Country": "PK", "City": "Quetta" }, 
    { "Country": "PK", "City": "Rawalpindi" }, 
    { "Country": "PK", "City": "Sahiwal" }, 
    { "Country": "PK", "City": "Sargodha" }, 
    { "Country": "PK", "City": "Sukkur" }, 
    { "Country": "PW", "City": "Koror" }, 
    { "Country": "PA", "City": "David" }, 
    { "Country": "PE", "City": "Arequipa" }, 
    { "Country": "PE", "City": "Cajamarca" }, 
    { "Country": "PE", "City": "Callao" }, 
    { "Country": "PE", "City": "Chancay" }, 
    { "Country": "PE", "City": "Chiclayo" }, 
    { "Country": "PE", "City": "Cusco" }, 
    { "Country": "PE", "City": "Huacho" }, 
    { "Country": "PE", "City": "Huancayo" }, 
    { "Country": "PE", "City": "Huaraz" }, 
    { "Country": "PE", "City": "Ica" }, 
    { "Country": "PE", "City": "Iquitos" }, 
    { "Country": "PE", "City": "Juliaca" }, 
    { "Country": "PE", "City": "Lima" }, 
    { "Country": "PE", "City": "Moquegua" }, 
    { "Country": "PE", "City": "Paita" }, 
    { "Country": "PE", "City": "Pisco" }, 
    { "Country": "PE", "City": "Piura" }, 
    { "Country": "PE", "City": "Puno" }, 
    { "Country": "PE", "City": "Tacna" }, 
    { "Country": "PE", "City": "Trujillo" }, 
    { "Country": "PH", "City": "Antipolo" }, 
    { "Country": "PH", "City": "Balanga" }, 
    { "Country": "PH", "City": "Batangas" }, 
    { "Country": "PH", "City": "Bayombong" }, 
    { "Country": "PH", "City": "Butuan" }, 
    { "Country": "PH", "City": "Dagupan" }, 
    { "Country": "PH", "City": "Kidapawan" }, 
    { "Country": "PH", "City": "Koronadal" }, 
    { "Country": "PH", "City": "Legazpi" }, 
    { "Country": "PH", "City": "Malabon" }, 
    { "Country": "PH", "City": "Malaybalay" }, 
    { "Country": "PH", "City": "Malolos" }, 
    { "Country": "PH", "City": "Manila" }, 
    { "Country": "PH", "City": "Masbate" }, 
    { "Country": "PH", "City": "Nabunturan" }, 
    { "Country": "PH", "City": "Naga" }, 
    { "Country": "PH", "City": "Navotas" }, 
    { "Country": "PH", "City": "Siquijor" }, 
    { "Country": "PH", "City": "Sorsogon" }, 
    { "Country": "PH", "City": "Tandag" }, 
    { "Country": "PH", "City": "Valenzuela" }, 
    { "Country": "PH", "City": "Vigan" }, 
    { "Country": "PL", "City": "Bydgoszcz" }, 
    { "Country": "PL", "City": "Gdynia" }, 
    { "Country": "PL", "City": "Gliwice" }, 
    { "Country": "PL", "City": "Katowice" }, 
    { "Country": "PL", "City": "Koszalin" }, 
    { "Country": "PL", "City": "Krakow" }, 
    { "Country": "PL", "City": "Lublin" }, 
    { "Country": "PL", "City": "Olsztyn" }, 
    { "Country": "PL", "City": "Opole" }, 
    { "Country": "PL", "City": "Poznan" }, 
    { "Country": "PL", "City": "Szczecin" }, 
    { "Country": "PL", "City": "Warsaw" }, 
    { "Country": "PT", "City": "Beja" }, 
    { "Country": "PT", "City": "Braga" }, 
    { "Country": "PT", "City": "Evora" }, 
    { "Country": "PT", "City": "Faro" }, 
    { "Country": "PT", "City": "Funchal" }, 
    { "Country": "PT", "City": "Guarda" }, 
    { "Country": "PT", "City": "Leiria" }, 
    { "Country": "PT", "City": "Lisbon" }, 
    { "Country": "PT", "City": "Porto" }, 
    { "Country": "PT", "City": "Viseu" }, 
    { "Country": "QA", "City": "Doha" }, 
    { "Country": "RO", "City": "Arad" }, 
    { "Country": "RO", "City": "Bacau" }, 
    { "Country": "RO", "City": "Botosani" }, 
    { "Country": "RO", "City": "Braila" }, 
    { "Country": "RO", "City": "Brasov" }, 
    { "Country": "RO", "City": "Bucharest" }, 
    { "Country": "RO", "City": "Buzau" }, 
    { "Country": "RO", "City": "Cluj-Napoca" }, 
    { "Country": "RO", "City": "Craiova" }, 
    { "Country": "RO", "City": "Deva" }, 
    { "Country": "RO", "City": "Galati" }, 
    { "Country": "RO", "City": "Giurgiu" }, 
    { "Country": "RO", "City": "Iasi" }, 
    { "Country": "RO", "City": "Oradea" }, 
    { "Country": "RO", "City": "Sibiu" }, 
    { "Country": "RO", "City": "Slatina" }, 
    { "Country": "RO", "City": "Suceava" }, 
    { "Country": "RO", "City": "Vaslui" }, 
    { "Country": "RU", "City": "Abakan" }, 
    { "Country": "RU", "City": "Achinsk" }, 
    { "Country": "RU", "City": "Aldan" }, 
    { "Country": "RU", "City": "Aleysk" }, 
    { "Country": "RU", "City": "Angarsk" }, 
    { "Country": "RU", "City": "Apatity" }, 
    { "Country": "RU", "City": "Apsheronsk" }, 
    { "Country": "RU", "City": "Asbest" }, 
    { "Country": "RU", "City": "Asha" }, 
    { "Country": "RU", "City": "Astrakhan" }, 
    { "Country": "RU", "City": "Balakovo" }, 
    { "Country": "RU", "City": "Barnaul" }, 
    { "Country": "RU", "City": "Belebey" }, 
    { "Country": "RU", "City": "Belgorod" }, 
    { "Country": "RU", "City": "Belogorsk" }, 
    { "Country": "RU", "City": "Berezniki" }, 
    { "Country": "RU", "City": "Bezhetsk" }, 
    { "Country": "RU", "City": "Birobidzhan" }, 
    { "Country": "RU", "City": "Biysk" }, 
    { "Country": "RU", "City": "Blagodarnyy" }, 
    { "Country": "RU", "City": "Blagoveshchensk" }, 
    { "Country": "RU", "City": "Bodaybo" }, 
    { "Country": "RU", "City": "Bologoye" }, 
    { "Country": "RU", "City": "Borovichi" }, 
    { "Country": "RU", "City": "Bratsk" }, 
    { "Country": "RU", "City": "Bryansk" }, 
    { "Country": "RU", "City": "Buynaksk" }, 
    { "Country": "RU", "City": "Buzuluk" }, 
    { "Country": "RU", "City": "Chapayevsk" }, 
    { "Country": "RU", "City": "Cheboksary" }, 
    { "Country": "RU", "City": "Chelyabinsk" }, 
    { "Country": "RU", "City": "Cherepanovo" }, 
    { "Country": "RU", "City": "Cherepovets" }, 
    { "Country": "RU", "City": "Cherkessk" }, 
    { "Country": "RU", "City": "Chernogorsk" }, 
    { "Country": "RU", "City": "Chita" }, 
    { "Country": "RU", "City": "Chusovoy" }, 
    { "Country": "RU", "City": "Derbent" }, 
    { "Country": "RU", "City": "Dimitrovgrad" }, 
    { "Country": "RU", "City": "Dzerzhinsk" }, 
    { "Country": "RU", "City": "Elista" }, 
    { "Country": "RU", "City": "Frolovo" }, 
    { "Country": "RU", "City": "Gatchina" }, 
    { "Country": "RU", "City": "Gelendzhik" }, 
    { "Country": "RU", "City": "Gornyak" }, 
    { "Country": "RU", "City": "Gryazi" }, 
    { "Country": "RU", "City": "Gubkin" }, 
    { "Country": "RU", "City": "Inta" }, 
    { "Country": "RU", "City": "Irkutsk" }, 
    { "Country": "RU", "City": "Ishim" }, 
    { "Country": "RU", "City": "Iskitim" }, 
    { "Country": "RU", "City": "Ivanovo" }, 
    { "Country": "RU", "City": "Izhevsk" }, 
    { "Country": "RU", "City": "Kaliningrad" }, 
    { "Country": "RU", "City": "Kaluga" }, 
    { "Country": "RU", "City": "Kamenka" }, 
    { "Country": "RU", "City": "Kamyshin" }, 
    { "Country": "RU", "City": "Kansk" }, 
    { "Country": "RU", "City": "Kaspiysk" }, 
    { "Country": "RU", "City": "Kemerovo" }, 
    { "Country": "RU", "City": "Khabarovsk" }, 
    { "Country": "RU", "City": "Kineshma" }, 
    { "Country": "RU", "City": "Kirov" }, 
    { "Country": "RU", "City": "Kirovo-Chepetsk" }, 
    { "Country": "RU", "City": "Kislovodsk" }, 
    { "Country": "RU", "City": "Kizel" }, 
    { "Country": "RU", "City": "Klintsy" }, 
    { "Country": "RU", "City": "Kolpashevo" }, 
    { "Country": "RU", "City": "Kostroma" }, 
    { "Country": "RU", "City": "Kotovsk" }, 
    { "Country": "RU", "City": "Krasnoarmeysk" }, 
    { "Country": "RU", "City": "Krasnodar" }, 
    { "Country": "RU", "City": "Krasnoyarsk" }, 
    { "Country": "RU", "City": "Kropotkin" }, 
    { "Country": "RU", "City": "Kumertau" }, 
    { "Country": "RU", "City": "Kurgan" }, 
    { "Country": "RU", "City": "Kursk" }, 
    { "Country": "RU", "City": "Kuznetsk" }, 
    { "Country": "RU", "City": "Leninogorsk" }, 
    { "Country": "RU", "City": "Lesosibirsk" }, 
    { "Country": "RU", "City": "Lipetsk" }, 
    { "Country": "RU", "City": "Magadan" }, 
    { "Country": "RU", "City": "Magas" }, 
    { "Country": "RU", "City": "Magnitogorsk" }, 
    { "Country": "RU", "City": "Makhachkala" }, 
    { "Country": "RU", "City": "Mariinsk" }, 
    { "Country": "RU", "City": "Maykop" }, 
    { "Country": "RU", "City": "Miass" }, 
    { "Country": "RU", "City": "Millerovo" }, 
    { "Country": "RU", "City": "Mirnyy" }, 
    { "Country": "RU", "City": "Moscow" }, 
    { "Country": "RU", "City": "Mozdok" }, 
    { "Country": "RU", "City": "Murmansk" }, 
    { "Country": "RU", "City": "Murom" }, 
    { "Country": "RU", "City": "Nadym" }, 
    { "Country": "RU", "City": "Nakhodka" }, 
    { "Country": "RU", "City": "Neftekamsk" }, 
    { "Country": "RU", "City": "Neryungri" }, 
    { "Country": "RU", "City": "Nevinnomyssk" }, 
    { "Country": "RU", "City": "Nizhnekamsk" }, 
    { "Country": "RU", "City": "Nizhneudinsk" }, 
    { "Country": "RU", "City": "Noginsk" }, 
    { "Country": "RU", "City": "Novoaltaysk" }, 
    { "Country": "RU", "City": "Novocherkassk" }, 
    { "Country": "RU", "City": "Novokuznetsk" }, 
    { "Country": "RU", "City": "Novomoskovsk" }, 
    { "Country": "RU", "City": "Novorossiysk" }, 
    { "Country": "RU", "City": "Novosibirsk" }, 
    { "Country": "RU", "City": "Novotroitsk" }, 
    { "Country": "RU", "City": "Obninsk" }, 
    { "Country": "RU", "City": "Okha" }, 
    { "Country": "RU", "City": "Omsk" }, 
    { "Country": "RU", "City": "Orenburg" }, 
    { "Country": "RU", "City": "Orsk" }, 
    { "Country": "RU", "City": "Otradnyy" }, 
    { "Country": "RU", "City": "Partizansk" }, 
    { "Country": "RU", "City": "Penza" }, 
    { "Country": "RU", "City": "Perm" }, 
    { "Country": "RU", "City": "Pervouralsk" }, 
    { "Country": "RU", "City": "Petrozavodsk" }, 
    { "Country": "RU", "City": "Podolsk" }, 
    { "Country": "RU", "City": "Polyarnyy" }, 
    { "Country": "RU", "City": "Poronaysk" }, 
    { "Country": "RU", "City": "Progress" }, 
    { "Country": "RU", "City": "Pskov" }, 
    { "Country": "RU", "City": "Pyatigorsk" }, 
    { "Country": "RU", "City": "Rubtsovsk" }, 
    { "Country": "RU", "City": "Ruzayevka" }, 
    { "Country": "RU", "City": "Ryazan" }, 
    { "Country": "RU", "City": "Rybinsk" }, 
    { "Country": "RU", "City": "Salekhard" }, 
    { "Country": "RU", "City": "Samara" }, 
    { "Country": "RU", "City": "Saransk" }, 
    { "Country": "RU", "City": "Saratov" }, 
    { "Country": "RU", "City": "Sasovo" }, 
    { "Country": "RU", "City": "Sayanogorsk" }, 
    { "Country": "RU", "City": "Serov" }, 
    { "Country": "RU", "City": "Serpukhov" }, 
    { "Country": "RU", "City": "Severodvinsk" }, 
    { "Country": "RU", "City": "Severomorsk" }, 
    { "Country": "RU", "City": "Shadrinsk" }, 
    { "Country": "RU", "City": "Shebekino" }, 
    { "Country": "RU", "City": "Slobodskoy" }, 
    { "Country": "RU", "City": "Smolensk" }, 
    { "Country": "RU", "City": "Sochi" }, 
    { "Country": "RU", "City": "Sokol" }, 
    { "Country": "RU", "City": "Solnechnogorsk" }, 
    { "Country": "RU", "City": "Sosnogorsk" }, 
    { "Country": "RU", "City": "Sovetsk" }, 
    { "Country": "RU", "City": "Stavropol" }, 
    { "Country": "RU", "City": "Sterlitamak" }, 
    { "Country": "RU", "City": "Surgut" }, 
    { "Country": "RU", "City": "Svobodnyy" }, 
    { "Country": "RU", "City": "Syktyvkar" }, 
    { "Country": "RU", "City": "Taganrog" }, 
    { "Country": "RU", "City": "Taksimo" }, 
    { "Country": "RU", "City": "Tambov" }, 
    { "Country": "RU", "City": "Tavda" }, 
    { "Country": "RU", "City": "Tayshet" }, 
    { "Country": "RU", "City": "Tikhoretsk" }, 
    { "Country": "RU", "City": "Tikhvin" }, 
    { "Country": "RU", "City": "Tolyatti" }, 
    { "Country": "RU", "City": "Tomsk" }, 
    { "Country": "RU", "City": "Tula" }, 
    { "Country": "RU", "City": "Tulun" }, 
    { "Country": "RU", "City": "Tuymazy" }, 
    { "Country": "RU", "City": "Tver" }, 
    { "Country": "RU", "City": "Tyumen" }, 
    { "Country": "RU", "City": "Ufa" }, 
    { "Country": "RU", "City": "Uglich" }, 
    { "Country": "RU", "City": "Ukhta" }, 
    { "Country": "RU", "City": "Ulyanovsk" }, 
    { "Country": "RU", "City": "Ussuriysk" }, 
    { "Country": "RU", "City": "Velsk" }, 
    { "Country": "RU", "City": "Verkhoyansk" }, 
    { "Country": "RU", "City": "Vladikavkaz" }, 
    { "Country": "RU", "City": "Vladimir" }, 
    { "Country": "RU", "City": "Vladivostok" }, 
    { "Country": "RU", "City": "Volgodonsk" }, 
    { "Country": "RU", "City": "Volgograd" }, 
    { "Country": "RU", "City": "Volkhov" }, 
    { "Country": "RU", "City": "Vologda" }, 
    { "Country": "RU", "City": "Volzhskiy" }, 
    { "Country": "RU", "City": "Vorkuta" }, 
    { "Country": "RU", "City": "Voronezh" }, 
    { "Country": "RU", "City": "Vyborg" }, 
    { "Country": "RU", "City": "Yakutsk" }, 
    { "Country": "RU", "City": "Yalutorovsk" }, 
    { "Country": "RU", "City": "Yaroslavl" }, 
    { "Country": "RU", "City": "Yefremov" }, 
    { "Country": "RU", "City": "Yekaterinburg" }, 
    { "Country": "RU", "City": "Yelets" }, 
    { "Country": "RU", "City": "Yemanzhelinsk" }, 
    { "Country": "RU", "City": "Yeysk" }, 
    { "Country": "RU", "City": "Zelenodolsk" }, 
    { "Country": "RU", "City": "Zeya" }, 
    { "Country": "RU", "City": "Zheleznogorsk" }, 
    { "Country": "RU", "City": "Zlatoust" }, 
    { "Country": "RW", "City": "Kigali" }, 
    { "Country": "RW", "City": "Nyanza" }, 
    { "Country": "KN", "City": "Basseterre" }, 
    { "Country": "LC", "City": "Castries" }, 
    { "Country": "VC", "City": "Kingstown" }, 
    { "Country": "SA", "City": "Jeddah" }, 
    { "Country": "SA", "City": "Makkah" }, 
    { "Country": "SA", "City": "Medina" }, 
    { "Country": "SA", "City": "Riyadh" }, 
    { "Country": "SA", "City": "Sakakah" }, 
    { "Country": "SN", "City": "Dakar" }, 
    { "Country": "RS", "City": "Becej" }, 
    { "Country": "RS", "City": "Belgrade" }, 
    { "Country": "RS", "City": "Bor" }, 
    { "Country": "RS", "City": "Jagodina" }, 
    { "Country": "RS", "City": "Kosjeric" }, 
    { "Country": "RS", "City": "Kovin" }, 
    { "Country": "RS", "City": "Kragujevac" }, 
    { "Country": "RS", "City": "Kraljevo" }, 
    { "Country": "RS", "City": "Kucevo" }, 
    { "Country": "RS", "City": "Lebane" }, 
    { "Country": "RS", "City": "Leskovac" }, 
    { "Country": "RS", "City": "Negotin" }, 
    { "Country": "RS", "City": "Paracin" }, 
    { "Country": "RS", "City": "Pirot" }, 
    { "Country": "RS", "City": "Prijepolje" }, 
    { "Country": "RS", "City": "Prokuplje" }, 
    { "Country": "RS", "City": "Raska" }, 
    { "Country": "RS", "City": "Sabac" }, 
    { "Country": "RS", "City": "Sombor" }, 
    { "Country": "RS", "City": "Trstenik" }, 
    { "Country": "RS", "City": "Vranje" }, 
    { "Country": "RS", "City": "Zajecar" }, 
    { "Country": "SL", "City": "Bo" }, 
    { "Country": "SG", "City": "Singapore" }, 
    { "Country": "SK", "City": "Bratislava" }, 
    { "Country": "SK", "City": "Nitra" }, 
    { "Country": "SK", "City": "Trnava" }, 
    { "Country": "SI", "City": "Crensovci" }, 
    { "Country": "SI", "City": "Izola" }, 
    { "Country": "SI", "City": "Kranj" }, 
    { "Country": "SI", "City": "Ljubljana" }, 
    { "Country": "SI", "City": "Maribor" }, 
    { "Country": "SI", "City": "Medvode" }, 
    { "Country": "SO", "City": "Mogadishu" }, 
    { "Country": "ZA", "City": "Benoni" }, 
    { "Country": "ZA", "City": "Bethlehem" }, 
    { "Country": "ZA", "City": "Bloemfontein" }, 
    { "Country": "ZA", "City": "Brits" }, 
    { "Country": "ZA", "City": "Durban" }, 
    { "Country": "ZA", "City": "Grahamstown" }, 
    { "Country": "ZA", "City": "Johannesburg" }, 
    { "Country": "ZA", "City": "Kimberley" }, 
    { "Country": "ZA", "City": "Klerksdorp" }, 
    { "Country": "ZA", "City": "Knysna" }, 
    { "Country": "ZA", "City": "Kroonstad" }, 
    { "Country": "ZA", "City": "Kuruman" }, 
    { "Country": "ZA", "City": "Nelspruit" }, 
    { "Country": "ZA", "City": "Oudtshoorn" }, 
    { "Country": "ZA", "City": "Paarl" }, 
    { "Country": "ZA", "City": "Pietermaritzburg" }, 
    { "Country": "ZA", "City": "Polokwane" }, 
    { "Country": "ZA", "City": "Potchefstroom" }, 
    { "Country": "ZA", "City": "Pretoria" }, 
    { "Country": "ZA", "City": "Rustenburg" }, 
    { "Country": "ZA", "City": "Springs" }, 
    { "Country": "ZA", "City": "Tzaneen" }, 
    { "Country": "ZA", "City": "Vereeniging" }, 
    { "Country": "ZA", "City": "Welkom" }, 
    { "Country": "ES", "City": "Albacete" }, 
    { "Country": "ES", "City": "Algeciras" }, 
    { "Country": "ES", "City": "Alicante" }, 
    { "Country": "ES", "City": "Arrecife" }, 
    { "Country": "ES", "City": "Badajoz" }, 
    { "Country": "ES", "City": "Barcelona" }, 
    { "Country": "ES", "City": "Bilbao" }, 
    { "Country": "ES", "City": "Burgos" }, 
    { "Country": "ES", "City": "Ceuta" }, 
    { "Country": "ES", "City": "Granada" }, 
    { "Country": "ES", "City": "Huelva" }, 
    { "Country": "ES", "City": "Linares" }, 
    { "Country": "ES", "City": "Lorca" }, 
    { "Country": "ES", "City": "Madrid" }, 
    { "Country": "ES", "City": "Marbella" }, 
    { "Country": "ES", "City": "Melilla" }, 
    { "Country": "ES", "City": "Murcia" }, 
    { "Country": "ES", "City": "Ourense" }, 
    { "Country": "ES", "City": "Oviedo" }, 
    { "Country": "ES", "City": "Palma" }, 
    { "Country": "ES", "City": "Pamplona" }, 
    { "Country": "ES", "City": "Santander" }, 
    { "Country": "ES", "City": "Seville" }, 
    { "Country": "ES", "City": "Tarragona" }, 
    { "Country": "ES", "City": "Toledo" }, 
    { "Country": "ES", "City": "Valencia" }, 
    { "Country": "ES", "City": "Valladolid" }, 
    { "Country": "ES", "City": "Vigo" }, 
    { "Country": "ES", "City": "Zaragoza" }, 
    { "Country": "LK", "City": "Anuradhapura" }, 
    { "Country": "LK", "City": "Colombo" }, 
    { "Country": "LK", "City": "Galle" }, 
    { "Country": "LK", "City": "Jaffna" }, 
    { "Country": "LK", "City": "Kandy" }, 
    { "Country": "LK", "City": "Moratuwa" }, 
    { "Country": "SD", "City": "Khartoum" }, 
    { "Country": "SR", "City": "Paramaribo" }, 
    { "Country": "SZ", "City": "Manzini" }, 
    { "Country": "SZ", "City": "Mbabane" }, 
    { "Country": "SE", "City": "Helsingborg" }, 
    { "Country": "SE", "City": "Kalmar" }, 
    { "Country": "SE", "City": "Karlstad" }, 
    { "Country": "CH", "City": "Aarau" }, 
    { "Country": "CH", "City": "Lausanne" }, 
    { "Country": "CH", "City": "Zurich" }, 
    { "Country": "SY", "City": "Aleppo" }, 
    { "Country": "SY", "City": "Damascus" }, 
    { "Country": "TW", "City": "Taichung" }, 
    { "Country": "TW", "City": "Taipei" }, 
    { "Country": "TW", "City": "Yilan" }, 
    { "Country": "TJ", "City": "Dushanbe" }, 
    { "Country": "TZ", "City": "Arusha" }, 
    { "Country": "TZ", "City": "Kasulu" }, 
    { "Country": "TZ", "City": "Kigoma" }, 
    { "Country": "TZ", "City": "Mbeya" }, 
    { "Country": "TZ", "City": "Morogoro" }, 
    { "Country": "TZ", "City": "Musoma" }, 
    { "Country": "TZ", "City": "Zanzibar" }, 
    { "Country": "TH", "City": "Ayutthaya" }, 
    { "Country": "TH", "City": "Bangkok" }, 
    { "Country": "TH", "City": "Buriram" }, 
    { "Country": "TH", "City": "Chachoengsao" }, 
    { "Country": "TH", "City": "Chaiyaphum" }, 
    { "Country": "TH", "City": "Chanthaburi" }, 
    { "Country": "TH", "City": "Chumphon" }, 
    { "Country": "TH", "City": "Kalasin" }, 
    { "Country": "TH", "City": "Kanchanaburi" }, 
    { "Country": "TH", "City": "Krabi" }, 
    { "Country": "TH", "City": "Lampang" }, 
    { "Country": "TH", "City": "Lamphun" }, 
    { "Country": "TH", "City": "Loei" }, 
    { "Country": "TH", "City": "Mukdahan" }, 
    { "Country": "TH", "City": "Nan" }, 
    { "Country": "TH", "City": "Narathiwat" }, 
    { "Country": "TH", "City": "Nonthaburi" }, 
    { "Country": "TH", "City": "Pattani" }, 
    { "Country": "TH", "City": "Phetchabun" }, 
    { "Country": "TH", "City": "Phetchaburi" }, 
    { "Country": "TH", "City": "Phichit" }, 
    { "Country": "TH", "City": "Phitsanulok" }, 
    { "Country": "TH", "City": "Phrae" }, 
    { "Country": "TH", "City": "Phuket" }, 
    { "Country": "TH", "City": "Ranong" }, 
    { "Country": "TH", "City": "Ratchaburi" }, 
    { "Country": "TH", "City": "Rayong" }, 
    { "Country": "TH", "City": "Saraburi" }, 
    { "Country": "TH", "City": "Songkhla" }, 
    { "Country": "TH", "City": "Surin" }, 
    { "Country": "TH", "City": "Tak" }, 
    { "Country": "TH", "City": "Uttaradit" }, 
    { "Country": "TH", "City": "Yala" }, 
    { "Country": "TH", "City": "Yasothon" }, 
    { "Country": "TL", "City": "Dili" }, 
    { "Country": "TL", "City": "Maliana" }, 
    { "Country": "TT", "City": "Arima" }, 
    { "Country": "TT", "City": "Chaguanas" }, 
    { "Country": "TT", "City": "Tunapuna" }, 
    { "Country": "TN", "City": "Bizerte" }, 
    { "Country": "TN", "City": "Gafsa" }, 
    { "Country": "TN", "City": "Jendouba" }, 
    { "Country": "TN", "City": "Kebili" }, 
    { "Country": "TN", "City": "Mahdia" }, 
    { "Country": "TN", "City": "Manouba" }, 
    { "Country": "TN", "City": "Monastir" }, 
    { "Country": "TN", "City": "Nabeul" }, 
    { "Country": "TN", "City": "Sfax" }, 
    { "Country": "TN", "City": "Siliana" }, 
    { "Country": "TN", "City": "Sousse" }, 
    { "Country": "TN", "City": "Tunis" }, 
    { "Country": "TN", "City": "Zaghouan" }, 
    { "Country": "TR", "City": "Adana" }, 
    { "Country": "TR", "City": "Ankara" }, 
    { "Country": "TR", "City": "Antalya" }, 
    { "Country": "TR", "City": "Artvin" }, 
    { "Country": "TR", "City": "Bartin" }, 
    { "Country": "TR", "City": "Batman" }, 
    { "Country": "TR", "City": "Bilecik" }, 
    { "Country": "TR", "City": "Bursa" }, 
    { "Country": "TR", "City": "Edirne" }, 
    { "Country": "TR", "City": "Gaziantep" }, 
    { "Country": "TR", "City": "Giresun" }, 
    { "Country": "TR", "City": "Isparta" }, 
    { "Country": "TR", "City": "Istanbul" }, 
    { "Country": "TR", "City": "Izmir" }, 
    { "Country": "TR", "City": "Kastamonu" }, 
    { "Country": "TR", "City": "Kayseri" }, 
    { "Country": "TR", "City": "Kilis" }, 
    { "Country": "TR", "City": "Konya" }, 
    { "Country": "TR", "City": "Malatya" }, 
    { "Country": "TR", "City": "Mardin" }, 
    { "Country": "TR", "City": "Mersin" }, 
    { "Country": "TR", "City": "Mugla" }, 
    { "Country": "TR", "City": "Ordu" }, 
    { "Country": "TR", "City": "Rize" }, 
    { "Country": "TR", "City": "Samsun" }, 
    { "Country": "TR", "City": "Sanliurfa" }, 
    { "Country": "TR", "City": "Sivas" }, 
    { "Country": "TR", "City": "Trabzon" }, 
    { "Country": "TR", "City": "Yalova" }, 
    { "Country": "TR", "City": "Yozgat" }, 
    { "Country": "TM", "City": "Mary" }, 
    { "Country": "UG", "City": "Kampala" }, 
    { "Country": "UA", "City": "Brovary" }, 
    { "Country": "UA", "City": "Cherkasy" }, 
    { "Country": "UA", "City": "Chernihiv" }, 
    { "Country": "UA", "City": "Chernivtsi" }, 
    { "Country": "UA", "City": "Dnipro" }, 
    { "Country": "UA", "City": "Donetsk" }, 
    { "Country": "UA", "City": "Drohobych" }, 
    { "Country": "UA", "City": "Horlivka" }, 
    { "Country": "UA", "City": "Ivano-Frankivsk" }, 
    { "Country": "UA", "City": "Kharkiv" }, 
    { "Country": "UA", "City": "Kherson" }, 
    { "Country": "UA", "City": "Korosten" }, 
    { "Country": "UA", "City": "Kovel" }, 
    { "Country": "UA", "City": "Kramatorsk" }, 
    { "Country": "UA", "City": "Kremenchuk" }, 
    { "Country": "UA", "City": "Luhansk" }, 
    { "Country": "UA", "City": "Lutsk" }, 
    { "Country": "UA", "City": "Makiyivka" }, 
    { "Country": "UA", "City": "Mariupol" }, 
    { "Country": "UA", "City": "Melitopol" }, 
    { "Country": "UA", "City": "Mykolayiv" }, 
    { "Country": "UA", "City": "Nikopol" }, 
    { "Country": "UA", "City": "Nizhyn" }, 
    { "Country": "UA", "City": "Poltava" }, 
    { "Country": "UA", "City": "Rivne" }, 
    { "Country": "UA", "City": "Shostka" }, 
    { "Country": "UA", "City": "Sumy" }, 
    { "Country": "UA", "City": "Ternopil" }, 
    { "Country": "UA", "City": "Zhytomyr" }, 
    { "Country": "AE", "City": "Ajman" }, 
    { "Country": "AE", "City": "Dubai" }, 
    { "Country": "AE", "City": "Sharjah" }, 
    { "Country": "GB", "City": "Ayr" }, 
    { "Country": "GB", "City": "Ballymena" }, 
    { "Country": "GB", "City": "Barnsley" }, 
    { "Country": "GB", "City": "Belfast" }, 
    { "Country": "GB", "City": "Bexleyheath" }, 
    { "Country": "GB", "City": "Birmingham" }, 
    { "Country": "GB", "City": "Blackburn" }, 
    { "Country": "GB", "City": "Blackpool" }, 
    { "Country": "GB", "City": "Bolton" }, 
    { "Country": "GB", "City": "Bracknell" }, 
    { "Country": "GB", "City": "Bradford" }, 
    { "Country": "GB", "City": "Bristol" }, 
    { "Country": "GB", "City": "Bury" }, 
    { "Country": "GB", "City": "Camberwell" }, 
    { "Country": "GB", "City": "Cardiff" }, 
    { "Country": "GB", "City": "Chelmsford" }, 
    { "Country": "GB", "City": "Coventry" }, 
    { "Country": "GB", "City": "Craigavon" }, 
    { "Country": "GB", "City": "Croydon" }, 
    { "Country": "GB", "City": "Dagenham" }, 
    { "Country": "GB", "City": "Darlington" }, 
    { "Country": "GB", "City": "Derby" }, 
    { "Country": "GB", "City": "Doncaster" }, 
    { "Country": "GB", "City": "Dudley" }, 
    { "Country": "GB", "City": "Dumbarton" }, 
    { "Country": "GB", "City": "Dundee" }, 
    { "Country": "GB", "City": "Durham" }, 
    { "Country": "GB", "City": "Edinburgh" }, 
    { "Country": "GB", "City": "Exeter" }, 
    { "Country": "GB", "City": "Falkirk" }, 
    { "Country": "GB", "City": "Gateshead" }, 
    { "Country": "GB", "City": "Glasgow" }, 
    { "Country": "GB", "City": "Glenrothes" }, 
    { "Country": "GB", "City": "Gloucester" }, 
    { "Country": "GB", "City": "Greenock" }, 
    { "Country": "GB", "City": "Hackney" }, 
    { "Country": "GB", "City": "Hammersmith" }, 
    { "Country": "GB", "City": "Hartlepool" }, 
    { "Country": "GB", "City": "Hendon" }, 
    { "Country": "GB", "City": "Hereford" }, 
    { "Country": "GB", "City": "Hounslow" }, 
    { "Country": "GB", "City": "Ilford" }, 
    { "Country": "GB", "City": "Ipswich" }, 
    { "Country": "GB", "City": "Islington" }, 
    { "Country": "GB", "City": "Kirkwall" }, 
    { "Country": "GB", "City": "Leeds" }, 
    { "Country": "GB", "City": "Leicester" }, 
    { "Country": "GB", "City": "Lincoln" }, 
    { "Country": "GB", "City": "Lisburn" }, 
    { "Country": "GB", "City": "Liverpool" }, 
    { "Country": "GB", "City": "Lochgilphead" }, 
    { "Country": "GB", "City": "London" }, 
    { "Country": "GB", "City": "Londonderry" }, 
    { "Country": "GB", "City": "Luton" }, 
    { "Country": "GB", "City": "Magherafelt" }, 
    { "Country": "GB", "City": "Maidenhead" }, 
    { "Country": "GB", "City": "Manchester" }, 
    { "Country": "GB", "City": "Middlesbrough" }, 
    { "Country": "GB", "City": "Newport" }, 
    { "Country": "GB", "City": "Newry" }, 
    { "Country": "GB", "City": "Northampton" }, 
    { "Country": "GB", "City": "Norwich" }, 
    { "Country": "GB", "City": "Nottingham" }, 
    { "Country": "GB", "City": "Oldham" }, 
    { "Country": "GB", "City": "Omagh" }, 
    { "Country": "GB", "City": "Oxford" }, 
    { "Country": "GB", "City": "Peterborough" }, 
    { "Country": "GB", "City": "Plymouth" }, 
    { "Country": "GB", "City": "Poplar" }, 
    { "Country": "GB", "City": "Preston" }, 
    { "Country": "GB", "City": "Reading" }, 
    { "Country": "GB", "City": "Romford" }, 
    { "Country": "GB", "City": "Rotherham" }, 
    { "Country": "GB", "City": "Salford" }, 
    { "Country": "GB", "City": "Scarborough" }, 
    { "Country": "GB", "City": "Scunthorpe" }, 
    { "Country": "GB", "City": "Sheffield" }, 
    { "Country": "GB", "City": "Shrewsbury" }, 
    { "Country": "GB", "City": "Slough" }, 
    { "Country": "GB", "City": "Southampton" }, 
    { "Country": "GB", "City": "Stockport" }, 
    { "Country": "GB", "City": "Sunderland" }, 
    { "Country": "GB", "City": "Swansea" }, 
    { "Country": "GB", "City": "Swindon" }, 
    { "Country": "GB", "City": "Taunton" }, 
    { "Country": "GB", "City": "Telford" }, 
    { "Country": "GB", "City": "Uxbridge" }, 
    { "Country": "GB", "City": "Wallasey" }, 
    { "Country": "GB", "City": "Wallsend" }, 
    { "Country": "GB", "City": "Warrington" }, 
    { "Country": "GB", "City": "Wembley" }, 
    { "Country": "GB", "City": "Weston-super-Mare" }, 
    { "Country": "GB", "City": "Widnes" }, 
    { "Country": "GB", "City": "Wigan" }, 
    { "Country": "GB", "City": "Wokingham" }, 
    { "Country": "GB", "City": "Wolverhampton" }, 
    { "Country": "GB", "City": "Woolwich" }, 
    { "Country": "GB", "City": "Worcester" }, 
    { "Country": "US", "City": "Abilene" }, 
    { "Country": "US", "City": "Acworth" }, 
    { "Country": "US", "City": "Adrian" }, 
    { "Country": "US", "City": "Aiken" }, 
    { "Country": "US", "City": "Akron" }, 
    { "Country": "US", "City": "Albany" }, 
    { "Country": "US", "City": "Albertville" }, 
    { "Country": "US", "City": "Albuquerque" }, 
    { "Country": "US", "City": "Alexandria" }, 
    { "Country": "US", "City": "Allentown" }, 
    { "Country": "US", "City": "Alsip" }, 
    { "Country": "US", "City": "Altoona" }, 
    { "Country": "US", "City": "Alvin" }, 
    { "Country": "US", "City": "Anaheim" }, 
    { "Country": "US", "City": "Anchorage" }, 
    { "Country": "US", "City": "Anderson" }, 
    { "Country": "US", "City": "Anniston" }, 
    { "Country": "US", "City": "Antioch" }, 
    { "Country": "US", "City": "Apex" }, 
    { "Country": "US", "City": "Apopka" }, 
    { "Country": "US", "City": "Appleton" }, 
    { "Country": "US", "City": "Arlington" }, 
    { "Country": "US", "City": "Asheville" }, 
    { "Country": "US", "City": "Atascadero" }, 
    { "Country": "US", "City": "Atlanta" }, 
    { "Country": "US", "City": "Auburn" }, 
    { "Country": "US", "City": "Augusta" }, 
    { "Country": "US", "City": "Aurora" }, 
    { "Country": "US", "City": "Austin" }, 
    { "Country": "US", "City": "Bakersfield" }, 
    { "Country": "US", "City": "Ballwin" }, 
    { "Country": "US", "City": "Baltimore" }, 
    { "Country": "US", "City": "Batavia" }, 
    { "Country": "US", "City": "Beaufort" }, 
    { "Country": "US", "City": "Beaumont" }, 
    { "Country": "US", "City": "Beaverton" }, 
    { "Country": "US", "City": "Bellflower" }, 
    { "Country": "US", "City": "Bellingham" }, 
    { "Country": "US", "City": "Belvidere" }, 
    { "Country": "US", "City": "Bethany" }, 
    { "Country": "US", "City": "Bettendorf" }, 
    { "Country": "US", "City": "Billings" }, 
    { "Country": "US", "City": "Binghamton" }, 
    { "Country": "US", "City": "Bixby" }, 
    { "Country": "US", "City": "Blacksburg" }, 
    { "Country": "US", "City": "Bloomfield" }, 
    { "Country": "US", "City": "Bloomington" }, 
    { "Country": "US", "City": "Blytheville" }, 
    { "Country": "US", "City": "Boise" }, 
    { "Country": "US", "City": "Bolingbrook" }, 
    { "Country": "US", "City": "Boston" }, 
    { "Country": "US", "City": "Bothell" }, 
    { "Country": "US", "City": "Bozeman" }, 
    { "Country": "US", "City": "Brandon" }, 
    { "Country": "US", "City": "Brockton" }, 
    { "Country": "US", "City": "Brookhaven" }, 
    { "Country": "US", "City": "Brooklyn" }, 
    { "Country": "US", "City": "Brownsburg" }, 
    { "Country": "US", "City": "Brownsville" }, 
    { "Country": "US", "City": "Buda" }, 
    { "Country": "US", "City": "Buffalo" }, 
    { "Country": "US", "City": "Burbank" }, 
    { "Country": "US", "City": "Burlington" }, 
    { "Country": "US", "City": "Butler" }, 
    { "Country": "US", "City": "Campbellsville" }, 
    { "Country": "US", "City": "Canton" }, 
    { "Country": "US", "City": "Carlsbad" }, 
    { "Country": "US", "City": "Carrollton" }, 
    { "Country": "US", "City": "Carson" }, 
    { "Country": "US", "City": "Carterville" }, 
    { "Country": "US", "City": "Cary" }, 
    { "Country": "US", "City": "Centreville" }, 
    { "Country": "US", "City": "Charleston" }, 
    { "Country": "US", "City": "Charlotte" }, 
    { "Country": "US", "City": "Charlottesville" }, 
    { "Country": "US", "City": "Chattanooga" }, 
    { "Country": "US", "City": "Chelsea" }, 
    { "Country": "US", "City": "Chesapeake" }, 
    { "Country": "US", "City": "Cheyenne" }, 
    { "Country": "US", "City": "Chicago" }, 
    { "Country": "US", "City": "Chicopee" }, 
    { "Country": "US", "City": "Chillicothe" }, 
    { "Country": "US", "City": "Cicero" }, 
    { "Country": "US", "City": "Cincinnati" }, 
    { "Country": "US", "City": "Clarksville" }, 
    { "Country": "US", "City": "Clayton" }, 
    { "Country": "US", "City": "Clemson" }, 
    { "Country": "US", "City": "Clermont" }, 
    { "Country": "US", "City": "Cleveland" }, 
    { "Country": "US", "City": "Clifton" }, 
    { "Country": "US", "City": "Clinton" }, 
    { "Country": "US", "City": "Columbia" }, 
    { "Country": "US", "City": "Columbus" }, 
    { "Country": "US", "City": "Concord" }, 
    { "Country": "US", "City": "Conshohocken" }, 
    { "Country": "US", "City": "Conway" }, 
    { "Country": "US", "City": "Conyers" }, 
    { "Country": "US", "City": "Coppell" }, 
    { "Country": "US", "City": "Corning" }, 
    { "Country": "US", "City": "Covina" }, 
    { "Country": "US", "City": "Cullman" }, 
    { "Country": "US", "City": "Dallas" }, 
    { "Country": "US", "City": "Danbury" }, 
    { "Country": "US", "City": "Darien" }, 
    { "Country": "US", "City": "Davenport" }, 
    { "Country": "US", "City": "Davis" }, 
    { "Country": "US", "City": "Dayton" }, 
    { "Country": "US", "City": "Dearborn" }, 
    { "Country": "US", "City": "Deltona" }, 
    { "Country": "US", "City": "Denver" }, 
    { "Country": "US", "City": "Detroit" }, 
    { "Country": "US", "City": "Dothan" }, 
    { "Country": "US", "City": "Douglasville" }, 
    { "Country": "US", "City": "Downey" }, 
    { "Country": "US", "City": "Dubuque" }, 
    { "Country": "US", "City": "Duluth" }, 
    { "Country": "US", "City": "Dyer" }, 
    { "Country": "US", "City": "Dyersburg" }, 
    { "Country": "US", "City": "Edinburg" }, 
    { "Country": "US", "City": "Elgin" }, 
    { "Country": "US", "City": "Elizabeth" }, 
    { "Country": "US", "City": "Emporia" }, 
    { "Country": "US", "City": "Enterprise" }, 
    { "Country": "US", "City": "Ephrata" }, 
    { "Country": "US", "City": "Erie" }, 
    { "Country": "US", "City": "Escondido" }, 
    { "Country": "US", "City": "Eugene" }, 
    { "Country": "US", "City": "Eunice" }, 
    { "Country": "US", "City": "Evansville" }, 
    { "Country": "US", "City": "Everett" }, 
    { "Country": "US", "City": "Fairfax" }, 
    { "Country": "US", "City": "Fairmont" }, 
    { "Country": "US", "City": "Fernley" }, 
    { "Country": "US", "City": "Florissant" }, 
    { "Country": "US", "City": "Flushing" }, 
    { "Country": "US", "City": "Franklin" }, 
    { "Country": "US", "City": "Fredonia" }, 
    { "Country": "US", "City": "Fremont" }, 
    { "Country": "US", "City": "Friendswood" }, 
    { "Country": "US", "City": "Fullerton" }, 
    { "Country": "US", "City": "Gaffney" }, 
    { "Country": "US", "City": "Gainesville" }, 
    { "Country": "US", "City": "Gaithersburg" }, 
    { "Country": "US", "City": "Galax" }, 
    { "Country": "US", "City": "Garland" }, 
    { "Country": "US", "City": "Gilbert" }, 
    { "Country": "US", "City": "Girard" }, 
    { "Country": "US", "City": "Glendale" }, 
    { "Country": "US", "City": "Glendora" }, 
    { "Country": "US", "City": "Gloversville" }, 
    { "Country": "US", "City": "Goshen" }, 
    { "Country": "US", "City": "Greeneville" }, 
    { "Country": "US", "City": "Greenfield" }, 
    { "Country": "US", "City": "Greensboro" }, 
    { "Country": "US", "City": "Greensburg" }, 
    { "Country": "US", "City": "Greenville" }, 
    { "Country": "US", "City": "Greenwood" }, 
    { "Country": "US", "City": "Greer" }, 
    { "Country": "US", "City": "Gresham" }, 
    { "Country": "US", "City": "Gurnee" }, 
    { "Country": "US", "City": "Gustine" }, 
    { "Country": "US", "City": "Hackensack" }, 
    { "Country": "US", "City": "Hagerstown" }, 
    { "Country": "US", "City": "Haledon" }, 
    { "Country": "US", "City": "Hammond" }, 
    { "Country": "US", "City": "Hanford" }, 
    { "Country": "US", "City": "Harlingen" }, 
    { "Country": "US", "City": "Harrisburg" }, 
    { "Country": "US", "City": "Hartselle" }, 
    { "Country": "US", "City": "Hawthorne" }, 
    { "Country": "US", "City": "Hayward" }, 
    { "Country": "US", "City": "Hemet" }, 
    { "Country": "US", "City": "Hempstead" }, 
    { "Country": "US", "City": "Henderson" }, 
    { "Country": "US", "City": "Hercules" }, 
    { "Country": "US", "City": "Hernando" }, 
    { "Country": "US", "City": "Herndon" }, 
    { "Country": "US", "City": "Hesperia" }, 
    { "Country": "US", "City": "Hialeah" }, 
    { "Country": "US", "City": "Highland" }, 
    { "Country": "US", "City": "Hilliard" }, 
    { "Country": "US", "City": "Hillsborough" }, 
    { "Country": "US", "City": "Hoboken" }, 
    { "Country": "US", "City": "Holland" }, 
    { "Country": "US", "City": "Hollister" }, 
    { "Country": "US", "City": "Hollywood" }, 
    { "Country": "US", "City": "Holyoke" }, 
    { "Country": "US", "City": "Houston" }, 
    { "Country": "US", "City": "Hudson" }, 
    { "Country": "US", "City": "Huntington" }, 
    { "Country": "US", "City": "Huntsville" }, 
    { "Country": "US", "City": "Hyattsville" }, 
    { "Country": "US", "City": "Imperial" }, 
    { "Country": "US", "City": "Indianapolis" }, 
    { "Country": "US", "City": "Indio" }, 
    { "Country": "US", "City": "Jacksonville" }, 
    { "Country": "US", "City": "Janesville" }, 
    { "Country": "US", "City": "Jasper" }, 
    { "Country": "US", "City": "Jeffersonville" }, 
    { "Country": "US", "City": "Jenks" }, 
    { "Country": "US", "City": "Johnsburg" }, 
    { "Country": "US", "City": "Kalamazoo" }, 
    { "Country": "US", "City": "Kankakee" }, 
    { "Country": "US", "City": "Katy" }, 
    { "Country": "US", "City": "Kearney" }, 
    { "Country": "US", "City": "Kearny" }, 
    { "Country": "US", "City": "Keller" }, 
    { "Country": "US", "City": "Kennesaw" }, 
    { "Country": "US", "City": "Kennett" }, 
    { "Country": "US", "City": "Kenosha" }, 
    { "Country": "US", "City": "Kent" }, 
    { "Country": "US", "City": "Killeen" }, 
    { "Country": "US", "City": "Kissimmee" }, 
    { "Country": "US", "City": "Knightdale" }, 
    { "Country": "US", "City": "Knoxville" }, 
    { "Country": "US", "City": "Kokomo" }, 
    { "Country": "US", "City": "Lafayette" }, 
    { "Country": "US", "City": "Lakeland" }, 
    { "Country": "US", "City": "Lakeville" }, 
    { "Country": "US", "City": "Lamar" }, 
    { "Country": "US", "City": "Lancaster" }, 
    { "Country": "US", "City": "Laredo" }, 
    { "Country": "US", "City": "Largo" }, 
    { "Country": "US", "City": "Laurel" }, 
    { "Country": "US", "City": "Laurinburg" }, 
    { "Country": "US", "City": "Lawrenceburg" }, 
    { "Country": "US", "City": "Lawrenceville" }, 
    { "Country": "US", "City": "Leander" }, 
    { "Country": "US", "City": "Lebanon" }, 
    { "Country": "US", "City": "Leesburg" }, 
    { "Country": "US", "City": "Lexington" }, 
    { "Country": "US", "City": "Liberty" }, 
    { "Country": "US", "City": "Littleton" }, 
    { "Country": "US", "City": "Livermore" }, 
    { "Country": "US", "City": "Livingston" }, 
    { "Country": "US", "City": "Livonia" }, 
    { "Country": "US", "City": "Loganville" }, 
    { "Country": "US", "City": "Lombard" }, 
    { "Country": "US", "City": "Longview" }, 
    { "Country": "US", "City": "Louisville" }, 
    { "Country": "US", "City": "Lowell" }, 
    { "Country": "US", "City": "Lyndhurst" }, 
    { "Country": "US", "City": "Lynn" }, 
    { "Country": "US", "City": "Lynnwood" }, 
    { "Country": "US", "City": "Lynwood" }, 
    { "Country": "US", "City": "Madera" }, 
    { "Country": "US", "City": "Madison" }, 
    { "Country": "US", "City": "Mahomet" }, 
    { "Country": "US", "City": "Malvern" }, 
    { "Country": "US", "City": "Manor" }, 
    { "Country": "US", "City": "Mansfield" }, 
    { "Country": "US", "City": "Marion" }, 
    { "Country": "US", "City": "Maryville" }, 
    { "Country": "US", "City": "Matawan" }, 
    { "Country": "US", "City": "Maywood" }, 
    { "Country": "US", "City": "McAllen" }, 
    { "Country": "US", "City": "McDonough" }, 
    { "Country": "US", "City": "McKeesport" }, 
    { "Country": "US", "City": "McKinney" }, 
    { "Country": "US", "City": "Mechanicsburg" }, 
    { "Country": "US", "City": "Media" }, 
    { "Country": "US", "City": "Memphis" }, 
    { "Country": "US", "City": "Meridian" }, 
    { "Country": "US", "City": "Mesa" }, 
    { "Country": "US", "City": "Mesquite" }, 
    { "Country": "US", "City": "Miami" }, 
    { "Country": "US", "City": "Middleton" }, 
    { "Country": "US", "City": "Middletown" }, 
    { "Country": "US", "City": "Midland" }, 
    { "Country": "US", "City": "Midvale" }, 
    { "Country": "US", "City": "Millsboro" }, 
    { "Country": "US", "City": "Milton" }, 
    { "Country": "US", "City": "Milwaukee" }, 
    { "Country": "US", "City": "Minneapolis" }, 
    { "Country": "US", "City": "Minooka" }, 
    { "Country": "US", "City": "Mission" }, 
    { "Country": "US", "City": "Mobile" }, 
    { "Country": "US", "City": "Modesto" }, 
    { "Country": "US", "City": "Monaca" }, 
    { "Country": "US", "City": "Monroeville" }, 
    { "Country": "US", "City": "Montgomery" }, 
    { "Country": "US", "City": "Morgantown" }, 
    { "Country": "US", "City": "Morrilton" }, 
    { "Country": "US", "City": "Mundelein" }, 
    { "Country": "US", "City": "Nacogdoches" }, 
    { "Country": "US", "City": "Nampa" }, 
    { "Country": "US", "City": "Nashville" }, 
    { "Country": "US", "City": "Newark" }, 
    { "Country": "US", "City": "Newburgh" }, 
    { "Country": "US", "City": "Newnan" }, 
    { "Country": "US", "City": "Norfolk" }, 
    { "Country": "US", "City": "Norman" }, 
    { "Country": "US", "City": "Novi" }, 
    { "Country": "US", "City": "Oakland" }, 
    { "Country": "US", "City": "Oceanside" }, 
    { "Country": "US", "City": "Ogden" }, 
    { "Country": "US", "City": "Olathe" }, 
    { "Country": "US", "City": "Olney" }, 
    { "Country": "US", "City": "Omaha" }, 
    { "Country": "US", "City": "Orange" }, 
    { "Country": "US", "City": "Orangeburg" }, 
    { "Country": "US", "City": "Orlando" }, 
    { "Country": "US", "City": "Oshkosh" }, 
    { "Country": "US", "City": "Oxnard" }, 
    { "Country": "US", "City": "Paducah" }, 
    { "Country": "US", "City": "Palmetto" }, 
    { "Country": "US", "City": "Paramus" }, 
    { "Country": "US", "City": "Parkersburg" }, 
    { "Country": "US", "City": "Parsons" }, 
    { "Country": "US", "City": "Passaic" }, 
    { "Country": "US", "City": "Paterson" }, 
    { "Country": "US", "City": "Peabody" }, 
    { "Country": "US", "City": "Pensacola" }, 
    { "Country": "US", "City": "Peoria" }, 
    { "Country": "US", "City": "Perkasie" }, 
    { "Country": "US", "City": "Perris" }, 
    { "Country": "US", "City": "Pflugerville" }, 
    { "Country": "US", "City": "Pharr" }, 
    { "Country": "US", "City": "Philadelphia" }, 
    { "Country": "US", "City": "Phoenix" }, 
    { "Country": "US", "City": "Pittsburg" }, 
    { "Country": "US", "City": "Pittsburgh" }, 
    { "Country": "US", "City": "Pittsfield" }, 
    { "Country": "US", "City": "Plainview" }, 
    { "Country": "US", "City": "Plano" }, 
    { "Country": "US", "City": "Pontiac" }, 
    { "Country": "US", "City": "Portage" }, 
    { "Country": "US", "City": "Portland" }, 
    { "Country": "US", "City": "Poughkeepsie" }, 
    { "Country": "US", "City": "Princeton" }, 
    { "Country": "US", "City": "Providence" }, 
    { "Country": "US", "City": "Radford" }, 
    { "Country": "US", "City": "Rahway" }, 
    { "Country": "US", "City": "Raleigh" }, 
    { "Country": "US", "City": "Redmond" }, 
    { "Country": "US", "City": "Reedley" }, 
    { "Country": "US", "City": "Reno" }, 
    { "Country": "US", "City": "Renton" }, 
    { "Country": "US", "City": "Reynoldsburg" }, 
    { "Country": "US", "City": "Richmond" }, 
    { "Country": "US", "City": "Riverside" }, 
    { "Country": "US", "City": "Riverview" }, 
    { "Country": "US", "City": "Roanoke" }, 
    { "Country": "US", "City": "Rockford" }, 
    { "Country": "US", "City": "Rockwood" }, 
    { "Country": "US", "City": "Rowlett" }, 
    { "Country": "US", "City": "Sacramento" }, 
    { "Country": "US", "City": "Salem" }, 
    { "Country": "US", "City": "Salina" }, 
    { "Country": "US", "City": "Sandy" }, 
    { "Country": "US", "City": "Sapulpa" }, 
    { "Country": "US", "City": "Saraland" }, 
    { "Country": "US", "City": "Sarasota" }, 
    { "Country": "US", "City": "Savannah" }, 
    { "Country": "US", "City": "Scarsdale" }, 
    { "Country": "US", "City": "Schenectady" }, 
    { "Country": "US", "City": "Scottsdale" }, 
    { "Country": "US", "City": "Seattle" }, 
    { "Country": "US", "City": "Secaucus" }, 
    { "Country": "US", "City": "Seneca" }, 
    { "Country": "US", "City": "Sevierville" }, 
    { "Country": "US", "City": "Shelbyville" }, 
    { "Country": "US", "City": "Shreveport" }, 
    { "Country": "US", "City": "Smithfield" }, 
    { "Country": "US", "City": "Snellville" }, 
    { "Country": "US", "City": "Somerset" }, 
    { "Country": "US", "City": "Southaven" }, 
    { "Country": "US", "City": "Southfield" }, 
    { "Country": "US", "City": "Southlake" }, 
    { "Country": "US", "City": "Spartanburg" }, 
    { "Country": "US", "City": "Spokane" }, 
    { "Country": "US", "City": "Springfield" }, 
    { "Country": "US", "City": "Stafford" }, 
    { "Country": "US", "City": "Statesboro" }, 
    { "Country": "US", "City": "Statesville" }, 
    { "Country": "US", "City": "Stockton" }, 
    { "Country": "US", "City": "Suffolk" }, 
    { "Country": "US", "City": "Summerville" }, 
    { "Country": "US", "City": "Sumner" }, 
    { "Country": "US", "City": "Sunnyvale" }, 
    { "Country": "US", "City": "Tacoma" }, 
    { "Country": "US", "City": "Tallahassee" }, 
    { "Country": "US", "City": "Tampa" }, 
    { "Country": "US", "City": "Temecula" }, 
    { "Country": "US", "City": "Tempe" }, 
    { "Country": "US", "City": "Texarkana" }, 
    { "Country": "US", "City": "Thibodaux" }, 
    { "Country": "US", "City": "Thomasville" }, 
    { "Country": "US", "City": "Trenton" }, 
    { "Country": "US", "City": "Trinity" }, 
    { "Country": "US", "City": "Tucson" }, 
    { "Country": "US", "City": "Tulsa" }, 
    { "Country": "US", "City": "Tupelo" }, 
    { "Country": "US", "City": "Tyler" }, 
    { "Country": "US", "City": "Urbandale" }, 
    { "Country": "US", "City": "Vallejo" }, 
    { "Country": "US", "City": "Vicksburg" }, 
    { "Country": "US", "City": "Victorville" }, 
    { "Country": "US", "City": "Vineland" }, 
    { "Country": "US", "City": "Waltham" }, 
    { "Country": "US", "City": "Warren" }, 
    { "Country": "US", "City": "Washington" }, 
    { "Country": "US", "City": "Waterbury" }, 
    { "Country": "US", "City": "Waterville" }, 
    { "Country": "US", "City": "Watsonville" }, 
    { "Country": "US", "City": "Waverly" }, 
    { "Country": "US", "City": "Wayne" }, 
    { "Country": "US", "City": "Waynesville" }, 
    { "Country": "US", "City": "Westbrook" }, 
    { "Country": "US", "City": "Westerville" }, 
    { "Country": "US", "City": "Westfield" }, 
    { "Country": "US", "City": "Westland" }, 
    { "Country": "US", "City": "Westminster" }, 
    { "Country": "US", "City": "Whittier" }, 
    { "Country": "US", "City": "Wichita" }, 
    { "Country": "US", "City": "Wilkes-Barre" }, 
    { "Country": "US", "City": "Wilmington" }, 
    { "Country": "US", "City": "Wilson" }, 
    { "Country": "US", "City": "Winston-Salem" }, 
    { "Country": "US", "City": "Woodhaven" }, 
    { "Country": "US", "City": "Woodinville" }, 
    { "Country": "US", "City": "Woodside" }, 
    { "Country": "US", "City": "Woodstock" }, 
    { "Country": "US", "City": "Yonkers" }, 
    { "Country": "US", "City": "Ypsilanti" }, 
    { "Country": "US", "City": "Yucaipa" }, 
    { "Country": "UY", "City": "Aigua" }, 
    { "Country": "UY", "City": "Canelones" }, 
    { "Country": "UY", "City": "Castillos" }, 
    { "Country": "UY", "City": "Maldonado" }, 
    { "Country": "UY", "City": "Minas" }, 
    { "Country": "UY", "City": "Montevideo" }, 
    { "Country": "UY", "City": "Salto" }, 
    { "Country": "UZ", "City": "Navoiy" }, 
    { "Country": "UZ", "City": "Tashkent" }, 
    { "Country": "VE", "City": "Barinas" }, 
    { "Country": "VE", "City": "Barquisimeto" }, 
    { "Country": "VE", "City": "Cabimas" }, 
    { "Country": "VE", "City": "Caracas" }, 
    { "Country": "VE", "City": "Carora" }, 
    { "Country": "VE", "City": "Coro" }, 
    { "Country": "VE", "City": "Maiquetia" }, 
    { "Country": "VE", "City": "Maracaibo" }, 
    { "Country": "VE", "City": "Maracay" }, 
    { "Country": "VE", "City": "Porlamar" }, 
    { "Country": "VN", "City": "Haiphong" }, 
    { "Country": "VN", "City": "Hanoi" }, 
    { "Country": "VN", "City": "Vinh" }, 
    { "Country": "YE", "City": "Aden" }, 
    { "Country": "YE", "City": "Hajjah" }, 
    { "Country": "YE", "City": "Ibb" }, 
    { "Country": "YE", "City": "Lahij" }, 
    { "Country": "YE", "City": "Sanaa" }, 
    { "Country": "ZM", "City": "Lusaka" }, 
    { "Country": "ZM", "City": "Solwezi" }, 
    { "Country": "ZW", "City": "Bulawayo" }, 
    { "Country": "ZW", "City": "Harare" }
]